(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9877],{

/***/ 5113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1385);
/* harmony import */ var _styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Checkbox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var title = param.title, view = param.view, checkboxes = param.checkboxes, selected = param.selected, single = param.single, visibility = param.visibility, style = param.style, onChange = param.onChange;
    /** STATES */ var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
        var values = Array.isArray(selected) ? selected : [
            selected
        ];
        var validatedValues = checkboxes.filter(function(a) {
            return values.includes(a.value.toString());
        }).map(function(x) {
            return x.value.toString();
        });
        return single ? validatedValues[0] ? [
            validatedValues[0]
        ] : [] : validatedValues;
    }), cb = _$ref[0], setCb = _$ref[1];
    /** HANDLERS */ var handleCheckboxClick = function(v) {
        var newCb = cb.includes(v) ? cb.filter(function(item) {
            return item !== v;
        }) : single ? [
            v
        ] : cb.concat([
            v
        ]);
        setCb(newCb);
        if (onChange) onChange(newCb);
    };
    /** HOOKS */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, function() {
        return {
            get: function get() {
                return cb;
            },
            set: function set(v) {
                var values = Array.isArray(v) ? v : [
                    v
                ];
                var validatedValues = checkboxes.filter(function(a) {
                    return values.includes(a.value.toString());
                }).map(function(x) {
                    return x.value.toString();
                });
                setCb(single ? [
                    validatedValues[0]
                ] : validatedValues);
            }
        };
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!selected.length) setCb([]);
        else setCb(Array.isArray(selected) ? single ? [
            selected[0]
        ] : selected : [
            selected
        ]);
    }, [
        selected
    ]);
    /** TEMPLATE */ if (!checkboxes.length || visibility === false) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cb),
            view !== "box" && (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[view]
        ].filter(Boolean).join(" "),
        style: style,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cbTitle),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: [
                    (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cbContent),
                    (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().inline)
                ].join(" "),
                children: checkboxes.map(function(value, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: [
                            (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cbChekbox),
                            cb.includes(value.value) && (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().active),
                            value.disabled && (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled)
                        ].filter(Boolean).join(" "),
                        onClick: function() {
                            return handleCheckboxClick(value.value);
                        },
                        disabled: value.disabled,
                        children: value.text
                    }, index);
                })
            })
        ]
    });
});
Checkbox.displayName = "Checkbox";
Checkbox.defaultProps = {
    checkboxes: [],
    selected: [],
    visibility: true,
    view: "box"
};
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);


/***/ }),

/***/ 8801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4914);
/* harmony import */ var _styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Radio = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var title = param.title, view = param.view, radios = param.radios, selected = param.selected, visibility = param.visibility, style = param.style, onChange = param.onChange;
    /** STATES */ var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(selected), rd = _$ref[0], setRd = _$ref[1];
    /** HOOKS */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return setRd(selected);
    }, [
        selected
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, function() {
        return {
            get: function get() {
                return rd;
            },
            set: function set(v) {
                if (!radios.filter(function(r) {
                    return r.value.toString() === v.toString();
                }).length) return;
                setRd(v.toString());
            }
        };
    });
    /** TEMPLATE */ if (!radios.length || !selected.toString().length || visibility === false) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rd),
            view !== "box" && (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[view]
        ].filter(Boolean).join(" "),
        style: style,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rdTitle),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: [
                    (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rdContent),
                    (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().inline)
                ].join(" "),
                children: radios.map(function(value, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: [
                            (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().rdRadio),
                            rd === value.value && (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().active),
                            value.disabled && (_styles_modules_Radio_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled)
                        ].filter(Boolean).join(" "),
                        onClick: function() {
                            if (rd !== value.value) {
                                setRd(value.value);
                                if (onChange) onChange(value.value);
                            }
                        },
                        disabled: value.disabled,
                        children: value.text
                    }, index);
                })
            })
        ]
    });
});
Radio.displayName = "Radio";
Radio.defaultProps = {
    radios: [],
    selected: "",
    visibility: true,
    view: "box"
};
/* harmony default export */ __webpack_exports__["Z"] = (Radio);


/***/ }),

/***/ 3177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7865);
/* harmony import */ var _styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1__);



var Skelet = function(param) {
    var children = param.children, height = param.height, maxHeight = param.maxHeight, width = param.width, maxWidth = param.maxWidth, style = param.style, className = param.className, invert = param.invert;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: [
            (_styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1___default().skelet),
            className,
            invert && (_styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1___default().invert)
        ].filter(Boolean).join(" "),
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            height: height,
            maxHeight: maxHeight,
            width: width,
            maxWidth: maxWidth
        }, style),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Skelet);


/***/ }),

/***/ 350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9815);
/* harmony import */ var _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3725);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5518);
/* harmony import */ var _context_location__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(637);
/* harmony import */ var _Skelet__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3177);
/* harmony import */ var _HomeNewsSkeletonItem__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8718);
/* harmony import */ var _styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9984);
/* harmony import */ var _styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_12__);














var HomeCarouselItem = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 7781).then(__webpack_require__.bind(__webpack_require__, 7781));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7781)
            ];
        }
    },
    suspense: true
});
var HomeCarousel = function(param) {
    var title = param.title, category = param.category, link = param.link;
    /** STATES */ var locationState = (0,_context_location__WEBPACK_IMPORTED_MODULE_8__/* .useLocationState */ .KJ)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isError = ref1[0], setIsError = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), data = ref2[0], setData = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), carouselScrollPosition = ref3[0], setCarouselScrollPosition = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), carouselScrollWidth = ref4[0], setCarouselScrollWidth = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), carouselElWidth = ref5[0], setCarouselElWidth = ref5[1];
    /** REFS */ var carouselContentEl = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    console.log(link);
    /** HOOKS */ (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!locationState.isLoaded) return;
        var fetchData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response;
                return _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return axios__WEBPACK_IMPORTED_MODULE_5___default().get("https://baza.estate/api/v2" + "/objects/top".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_6__/* .JSONToQuery */ .vp)({
                                location: locationState.region,
                                category: category,
                                length: 9
                            })));
                        case 3:
                            response = _ctx.sent;
                            if (!(!response.data || response.data.status !== "ok")) {
                                _ctx.next = 6;
                                break;
                            }
                            throw new Error(response.data.text);
                        case 6:
                            setData(response.data.data);
                            setIsLoading(false);
                            setIsError(false);
                            _ctx.next = 15;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                            setIsLoading(false);
                            setIsError(true);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        if (carouselContentEl.current) {
            carouselContentEl.current.scrollTo({
                left: 0,
                behavior: "auto"
            });
            setCarouselScrollPosition(0);
        }
    }, [
        locationState
    ]);
    /** HANDLERS */ var handlePreviousClick = function() {
        if (!carouselContentEl.current) return;
        carouselContentEl.current.scrollTo({
            left: carouselContentEl.current.scrollLeft - carouselContentEl.current.offsetWidth / 2,
            behavior: "smooth"
        });
        setCarouselScrollPosition(carouselScrollPosition - carouselContentEl.current.offsetWidth / 2);
        setCarouselScrollWidth(carouselContentEl.current.scrollWidth);
        setCarouselElWidth(carouselContentEl.current.offsetWidth);
    };
    var handleNextClick = function() {
        if (!carouselContentEl.current) return;
        var newLeft = carouselContentEl.current.scrollLeft + carouselContentEl.current.offsetWidth / 2;
        newLeft = newLeft < 0 ? 0 : newLeft;
        carouselContentEl.current.scrollTo({
            left: newLeft,
            behavior: "smooth"
        });
        setCarouselScrollPosition(newLeft);
        setCarouselScrollWidth(carouselContentEl.current.scrollWidth);
        setCarouselElWidth(carouselContentEl.current.offsetWidth);
    };
    /** TEMPLATES */ if (isLoading || isError) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
        className: "block crop",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "fixed",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        style: {
                            maxWidth: 400,
                            width: "100%",
                            height: 47.5
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: (_styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_12___default().carousel),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (_styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_12___default().carouselContent),
                        children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(Array(6).keys()).map(function(value) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_HomeNewsSkeletonItem__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}, value);
                        })
                    })
                })
            ]
        })
    });
    if (data.length) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
        className: "block crop",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "fixed",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                    children: "".concat(title, " в ").concat(locationState.case)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_12___default().carousel),
                    children: [
                        carouselScrollPosition > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                            className: [
                                (_styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_12___default().carouselButton),
                                (_styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_12___default().carouselButtonPrevious)
                            ].join(" "),
                            onClick: handlePreviousClick,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "28",
                                height: "28",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("polyline", {
                                    points: "15 18 9 12 15 6"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: [
                                (_styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_12___default().carouselContent),
                                react_device_detect__WEBPACK_IMPORTED_MODULE_7__/* .isMobile */ .tq && (_styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_12___default().touch)
                            ].filter(Boolean).join(" "),
                            ref: carouselContentEl,
                            children: [
                                data.map(function(value, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
                                        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_HomeNewsSkeletonItem__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HomeCarouselItem, {
                                            item: value
                                        })
                                    }, index);
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    href: "/".concat(locationState.code, "/objects/buy/").concat(link),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                                        className: (_styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_12___default().carouselItemMore),
                                        type: "button",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                children: "Все предложения"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "100",
                                                height: "100",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "1",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("line", {
                                                        x1: "5",
                                                        y1: "12",
                                                        x2: "19",
                                                        y2: "12"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("polyline", {
                                                        points: "12 5 19 12 12 19"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: (_styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_12___default().carouselItemDummy)
                                })
                            ]
                        }),
                        carouselScrollPosition + carouselElWidth <= carouselScrollWidth && data.length >= 4 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                            className: [
                                (_styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_12___default().carouselButton),
                                (_styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_12___default().carouselButtonNext)
                            ].join(" "),
                            onClick: handleNextClick,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "28",
                                height: "28",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("polyline", {
                                    points: "9 18 15 12 9 6"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
    return;
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (HomeCarousel);


/***/ }),

/***/ 7247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7568);
/* harmony import */ var _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2077);
/* harmony import */ var _Skelet__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3177);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _HomeNewsSkeletonItem__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8718);
/* harmony import */ var _context_location__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(637);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3725);
/* harmony import */ var _styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8085);
/* harmony import */ var _styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12__);













var HomeNews = function() {
    /** STATES */ var locationState = (0,_context_location__WEBPACK_IMPORTED_MODULE_8__/* .useLocationState */ .KJ)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isError = ref1[0], setIsError = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), data = ref2[0], setData = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!locationState.isLoaded) return;
        var fetchData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response;
                return _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return axios__WEBPACK_IMPORTED_MODULE_9___default().get("https://baza.estate/api/v2" + "/faq/top" + "".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_10__/* .JSONToQuery */ .vp)({
                                location: locationState.region,
                                length: 10
                            })));
                        case 3:
                            response = _ctx.sent;
                            if (!(!response.data || response.data.status !== "ok")) {
                                _ctx.next = 7;
                                break;
                            }
                            console.log("err");
                            throw new Error(response.data.text);
                        case 7:
                            setData(response.data.data.data);
                            setIsLoading(false);
                            setIsError(false);
                            _ctx.next = 16;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](0);
                            setIsLoading(false);
                            setIsError(true);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        12
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, [
        locationState
    ]);
    /** TEMPLATES */ if (isLoading || isError) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
        className: "block crop",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "fixed",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Skelet__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        style: {
                            maxWidth: 400,
                            width: "100%",
                            height: 47.5
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journal),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalGroup),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_HomeNewsSkeletonItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}, "1")
                    })
                })
            ]
        })
    });
    var DateFormatter = new Intl.DateTimeFormat("ru-Ru", {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
    var lastNews = data.length > 0 ? data[0] : null;
    if (data.length) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
        className: "block crop",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "fixed",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                    children: "Новости"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journal),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalGroup),
                            children: [
                                data && data.slice(1, 5).map(function(value, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
                                        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_HomeNewsSkeletonItem__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                                            className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalGroupItem),
                                            href: "/".concat(value.slugCategory, "/").concat(value.slug),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalItemImage),
                                                    src: value.image,
                                                    alt: "",
                                                    width: 100,
                                                    height: 60
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalItemContent),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                            children: value.title
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                            className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalItemFooter),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                    className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalItemCategories),
                                                                    children: value.category.length ? value.category.join(" | ") : ""
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                    className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalItemDate),
                                                                    children: DateFormatter.format(new Date(value.created_at))
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, index);
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalGroupAction),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        type: "link",
                                        href: "/news",
                                        children: "Все новости"
                                    })
                                })
                            ]
                        }),
                        lastNews && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                            href: "/".concat(lastNews.slugCategory, "/").concat(lastNews.slug),
                            className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalItem),
                            children: [
                                lastNews.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalItemBackgroundImage),
                                    src: lastNews.image,
                                    layout: "fill",
                                    objectFit: "cover",
                                    alt: "",
                                    priority: true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalItemBackground)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalItemContent),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalItemTitle),
                                            children: lastNews.title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalItemDescription),
                                            children: lastNews.short_body
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalItemFooter),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalItemDate),
                                                    children: DateFormatter.format(new Date(lastNews.created_at))
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                    className: (_styles_modules_home_HomeNews_module_scss__WEBPACK_IMPORTED_MODULE_12___default().journalItemReadMore),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                            children: "Читать дальше"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            width: "28",
                                                            height: "28",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            style: {
                                                                position: "relative",
                                                                top: -1
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("line", {
                                                                    x1: "5",
                                                                    y1: "12",
                                                                    x2: "19",
                                                                    y2: "12"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("polyline", {
                                                                    points: "12 5 19 12 12 19"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
    return;
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (HomeNews);


/***/ }),

/***/ 8718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Skelet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3177);
/* harmony import */ var _styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9984);
/* harmony import */ var _styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var HomeCarouselSkeletonItem = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_2___default().carouselItem)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HomeCarouselSkeletonItem);


/***/ }),

/***/ 6942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ home_HomeUsefool; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./context/objects.js
var objects = __webpack_require__(1563);
// EXTERNAL MODULE: ./context/location.js
var context_location = __webpack_require__(637);
// EXTERNAL MODULE: ./context/buildings.js
var buildings = __webpack_require__(1000);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 6 modules
var useCookies = __webpack_require__(461);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(2077);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./styles/modules/home/HomeUsefool.module.scss
var HomeUsefool_module = __webpack_require__(2628);
var HomeUsefool_module_default = /*#__PURE__*/__webpack_require__.n(HomeUsefool_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./public/images/usefoolMap.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgUsefoolMap = function SvgUsefoolMap(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 260 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M.166 155.595s-.583 6.737 10.205 11.645c11.33 5.158 66.895 2.496 52.691 8.568-10.122 4.326 5.915 7.736 46.444 8.901 20.826.624 111.714 2.121 90.387-9.774-15.828-8.859 61.647 3.826 59.814-19.382H.166v.042Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M45.86 155.47s-30.616-70.415-8.581-86.095c14.703-10.481 26.45 12.311 45.069.083 16.578-10.897 2.166-40.385 24.992-45.127 29.49-6.114 52.899 53.487 77.308 45.044 29.616-10.232 59.065 10.564 33.614 86.219l-172.403-.124Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M21.91 148.69c-.5-1.414-1.041-2.87-1.5-4.325l1.208-.333c.5 1.456 1 2.911 1.5 4.326l-1.208.332Zm215.514-1.83-1.249-.125c.208-1.497.416-2.994.583-4.491l1.249.124a183.035 183.035 0 0 1-.583 4.492Zm-218.388-6.904a87.36 87.36 0 0 1-1.25-4.409l1.208-.249 1.25 4.367-1.208.291Zm219.471-2.121-1.249-.125c.166-1.497.291-3.036.458-4.492l1.249.083c-.125 1.498-.291 2.995-.458 4.534ZM16.62 131.139c-.375-1.498-.708-2.995-1.041-4.451l1.25-.208c.332 1.456.666 2.953.999 4.409l-1.208.25Zm222.72-2.371-1.249-.083c.125-1.498.208-3.036.291-4.534l1.25.042c-.125 1.539-.208 3.078-.292 4.575Zm-224.678-6.572a83.988 83.988 0 0 1-.75-4.492l1.25-.166c.25 1.456.5 2.995.75 4.45l-1.25.208Zm225.136-2.495-1.249-.042c.042-1.497.083-3.036.083-4.533h1.25c0 1.539-.042 3.078-.084 4.575Zm-226.51-6.488c-.167-1.498-.334-3.037-.5-4.534l1.25-.083c.124 1.497.291 2.995.5 4.492l-1.25.125Zm225.344-2.579c0-1.497-.041-3.036-.083-4.534l1.249-.041c.042 1.497.084 3.036.084 4.533l-1.25.042Zm-226.177-6.488a170.994 170.994 0 0 1-.167-4.534h1.25c.041 1.497.083 2.995.166 4.492l-1.25.042Zm225.886-2.537a153.656 153.656 0 0 0-.334-4.492l1.25-.084c.125 1.498.25 2.995.333 4.534l-1.249.042ZM13.579 95.037l-1.25-.042c.042-1.538.084-3.077.209-4.533l1.25.083c-.125 1.497-.167 2.995-.209 4.492Zm224.012-2.454a148.635 148.635 0 0 0-.583-4.492l1.249-.125c.209 1.456.417 2.995.583 4.534l-1.249.083Zm-223.429-6.53-1.25-.125c.167-1.538.376-3.036.626-4.533l1.25.166a83.11 83.11 0 0 0-.626 4.492Zm222.179-2.412c-.25-1.497-.541-2.995-.833-4.45l1.25-.208c.291 1.455.583 2.953.875 4.492l-1.292.166Zm-148.66-.166c-1.75-.25-3-.957-4.749-2.205l.791-.873c1.542 1.081 2.625 1.705 4.082 1.955l-.124 1.123Zm4.373-2.662-1.124-.5c.583-.998 1.082-2.412 1.5-4.159l1.207.25c-.416 1.83-.958 3.286-1.583 4.409Zm-12.829-2.745c-1-.999-2.083-2.163-3.29-3.494l.999-.707a72.103 72.103 0 0 0 3.207 3.452l-.916.749Zm-63.605-.915-1.25-.208c.334-1.498.709-2.995 1.084-4.45l1.208.249a136.414 136.414 0 0 0-1.042 4.409Zm218.847-2.371a110.925 110.925 0 0 0-1.208-4.367l1.208-.291a113.2 113.2 0 0 1 1.208 4.408l-1.208.25ZM94.512 71.829l-1.25-.125c.208-1.33.375-2.828.542-4.492l1.25.083c-.167 1.706-.334 3.203-.542 4.534Zm-21.618-.915c-1.042-1.248-2.083-2.537-3-3.66l1-.666c.917 1.123 1.958 2.413 3 3.66l-1 .666Zm92.012-.083c-.958 0-1.958-.25-2.874-.79l.666-.957c1.375.79 2.708.79 4.207.166l.542.998a5.786 5.786 0 0 1-2.541.583Zm-146.87-2.413-1.208-.332a76.783 76.783 0 0 1 1.625-4.326l1.166.374c-.541 1.415-1.083 2.829-1.583 4.284Zm153.534-1.081-.916-.749c.958-.915 1.958-2.08 3.124-3.493l1 .665a43.092 43.092 0 0 1-3.208 3.577Zm-13.079-.79c-.833-1.123-1.624-2.454-2.457-4.035l1.124-.499c.833 1.54 1.583 2.828 2.375 3.91l-1.042.624Zm73.393-.458a64.775 64.775 0 0 0-1.624-4.284l1.166-.374a58.563 58.563 0 0 1 1.625 4.326l-1.167.332ZM66.937 63.594c-1.166-1.414-2.124-2.579-2.999-3.619l1-.665c.916 1.081 1.874 2.246 3.04 3.66l-1.04.624Zm28.491-.832-1.25-.083c.084-1.331.209-2.787.292-4.534l1.25.042c-.084 1.747-.209 3.244-.292 4.575Zm-73.893-2.787-1.166-.457c.708-1.414 1.416-2.787 2.207-4.118l1.125.54a53.923 53.923 0 0 0-2.166 4.035Zm156.117 0-1.042-.624c.875-1.206 1.833-2.495 2.75-3.785l1.041.624c-.917 1.29-1.833 2.58-2.749 3.785Zm-23.659-1.663a79.213 79.213 0 0 1-1.791-4.284l1.166-.375a94.603 94.603 0 0 0 1.791 4.243l-1.166.416Zm74.434-.707a53.316 53.316 0 0 0-2.124-4.076l1.124-.5a95.066 95.066 0 0 1 2.166 4.118l-1.166.458ZM60.814 56.398a91.381 91.381 0 0 0-3.249-3.452l.958-.748c1.042 1.081 2.125 2.204 3.29 3.493l-.999.707Zm35.156-2.703-1.25-.042c.083-1.497.167-2.994.25-4.533l1.25.041c-.084 1.498-.167 2.995-.25 4.534Zm87.18-1.331-1.041-.624a104.313 104.313 0 0 1 2.874-3.743l1.041.665a100.068 100.068 0 0 0-2.874 3.702ZM26.2 52.073l-1.041-.624c1-1.373 2-2.62 3.04-3.702l.959.707c-1.042 1.04-2 2.246-2.958 3.619Zm124.294-2.33c-.583-1.497-1.125-3.035-1.625-4.325l1.208-.374c.458 1.29 1.042 2.786 1.625 4.284l-1.208.416Zm-96.386-.04c-1.291-1.124-2.54-2.122-3.749-2.954l.75-.873c1.25.873 2.54 1.871 3.874 3.036l-.875.79Zm169.737-.084c-.916-1.331-1.832-2.579-2.791-3.702l1-.665c1 1.164 1.958 2.454 2.874 3.785l-1.083.582ZM32.657 45.377l-.75-.916a16.175 16.175 0 0 1 4.623-2.204l.375 1.082c-1.458.416-2.874 1.123-4.248 2.038Zm156.366-.333-.958-.707a43.846 43.846 0 0 1 3.416-3.41l.874.79c-1.083.956-2.166 2.08-3.332 3.327Zm-92.512-.416-1.25-.083c.125-1.622.209-3.12.334-4.534l1.25.083c-.084 1.414-.209 2.87-.334 4.534Zm-50.317-.25c-1.583-.707-3.124-1.164-4.582-1.33l.167-1.124c1.624.208 3.29.666 4.956 1.415l-.541 1.04Zm171.612-1.83a29.088 29.088 0 0 0-3.708-2.911l.75-.915a28.844 28.844 0 0 1 3.874 3.036l-.916.79Zm-70.52-1.414c-.624-1.663-1.124-3.036-1.624-4.284l1.208-.374c.5 1.248 1 2.62 1.624 4.284l-1.208.374Zm48.86-2.287-.708-.915c1.541-.957 3.124-1.706 4.623-2.122l.375 1.082c-1.416.374-2.874 1.04-4.29 1.955Zm13.704-1.373c-1.541-.582-3.124-.956-4.665-1.081l.125-1.123c1.666.124 3.373.54 5.04 1.164l-.5 1.04ZM97.26 35.561l-1.249-.083c.167-1.58.334-3.12.5-4.534l1.25.125a371.689 371.689 0 0 0-.5 4.492Zm46.736-2.995c-.625-1.497-1.166-2.911-1.75-4.242l1.167-.416a90.752 90.752 0 0 1 1.749 4.284l-1.166.374Zm-45.61-5.989-1.25-.166c.25-1.58.541-3.078.833-4.492l1.25.208a86.133 86.133 0 0 0-.834 4.45Zm41.986-2.454c-.666-1.456-1.375-2.828-2.041-4.117l1.125-.458a98.77 98.77 0 0 1 2.041 4.16l-1.125.415Zm-40.07-6.405-1.208-.291a69.07 69.07 0 0 1 1.416-4.409l1.208.374c-.542 1.332-1 2.787-1.416 4.326Zm35.821-1.747a64.034 64.034 0 0 0-2.499-3.91l1.042-.582c.874 1.207 1.707 2.537 2.54 3.952l-1.083.54Zm-32.531-6.696-1.124-.5c.833-1.496 1.749-2.827 2.707-3.95l1 .707a23.651 23.651 0 0 0-2.583 3.743Zm27.158-.873a27.175 27.175 0 0 0-3.374-3.245l.833-.831a26.493 26.493 0 0 1 3.499 3.368l-.958.708ZM109.674 2.62l-.667-.956C110.507.79 112.131.25 113.881 0l.208 1.123c-1.583.25-3.083.749-4.415 1.497Zm13.745 0a16.52 16.52 0 0 0-4.54-1.455l.208-1.123c1.666.25 3.332.79 4.915 1.538l-.583 1.04Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M246.129 120.325c-10.413-1.539-9.497 21.669-24.367 21.669-13.579 0-20.868-51.823-35.78-41.301-59.981 42.382-13.287-29.738-53.608-31.152-18.244-.624-30.365 18.758-34.864 53.154-6.498 31.069-21.534-23.707-37.071-18.591-9.83 3.244-8.706 37.89-22.326 37.89-14.87 0-13.87-19.507-24.326-17.968C2.624 125.69 0 155.927 0 155.927h260c-.042 0-2.624-33.939-13.871-35.602Z",
    fill: "#FAFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M236.132 144.698c-9.58-.666-8.039 5.282-21.701 5.282-12.496 0-12.163-13.351-20.535-16.179-15.412-5.241-28.116 21.211-34.072 7.944-11.33-35.187-44.445-52.864-59.69 0-5.956 13.267-19.952-10.398-34.072-7.944-8.706 1.497-8.04 16.179-20.535 16.179-13.663 0-12.121-5.948-21.701-5.282-10.33.707-13.413 11.229-13.413 11.229h239.173c-.041 0-3.124-10.522-13.454-11.229Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M64.02 88.632c-7.039-7.944-12.537-16.138-16.786-23.707 1.125.665 6.123.915 6.207-.167.083-1.206-5.998-1.663-6.748-.831-.292-.5-.542-1.04-.833-1.54 1.083.583 6.415.084 6.373-1.04-.125-1.205-6.165-.706-6.79.209-.333-.624-.666-1.29-1-1.913 1.125.54 6.332.041 6.249-1.082-.125-1.206-5.957-.707-6.706.166-.334-.623-.625-1.247-.917-1.871 1 .582 6.665-.79 6.415-1.955-.292-1.165-6.332.291-6.706 1.373a34.328 34.328 0 0 1-.834-1.789c1.125.458 6.457-.873 6.207-1.996-.292-1.165-5.957.208-6.581 1.206a45.116 45.116 0 0 1-.917-2.08c1.125.416 6.415-.915 6.165-2.038-.292-1.123-5.873.208-6.54 1.165-.208-.54-.416-1.04-.624-1.539 1.124.333 6.33-1.913 5.873-3.036-.5-1.04-5.665 1.164-6.207 2.204-.291-.707-.541-1.414-.833-2.08 1.166.25 6.207-1.954 5.79-3.036-.458-1.04-5.456 1.082-6.123 2.08-.208-.54-.375-1.04-.583-1.58 1.125.25 5.956-3.245 5.29-4.201-.708-.915-5.165 2.246-5.582 3.41-.208-.624-.458-1.247-.666-1.871 1.124.208 5.915-3.245 5.248-4.201-.666-.915-5.082 2.204-5.54 3.327-.208-.665-.416-1.29-.624-1.913 1.25-.166 5.414-3.244 4.79-4.118-.542-.831-4.457 1.747-5.165 2.829-.167-.624-.375-1.207-.5-1.747 1.166-.167 5.081-4.16 4.29-4.991-.708-.749-4.124 2.495-4.623 3.701-.125-.499-.292-.998-.375-1.455 1.124.041 5.081-4.534 4.165-5.366-.792-.707-4.124 2.954-4.457 4.201-.167-.707-.333-1.372-.458-1.913 1.166-.125 4.915-4.534 4.04-5.324-.75-.665-3.873 2.704-4.332 3.91-.125-.5-.166-.915-.208-1.165.625-1.04.167-6.53-1-6.446-.541.041-.833 1.622-.708 3.535.125 2.246.792 2.62 1.083 4.284-.791-1.082-4.665-3.452-5.165-2.62-.666.998 4.457 4.492 5.498 4.076.125.54.25 1.123.417 1.746-.916-.915-5.457-2.578-5.831-1.622-.417 1.123 5.081 3.328 6.123 2.829.125.54.291 1.123.458 1.746-1-.831-5.623-2.08-5.915-1.081-.333 1.123 5.207 2.828 6.248 2.33l.5 1.746c-1.083-.749-5.832-1.622-6.04-.582-.208 1.164 5.373 2.329 6.415 1.747.166.54.375 1.123.541 1.746-1.083-.665-6.165-.956-6.248.125-.041 1.165 5.665 1.622 6.581.915.167.54.375 1.082.584 1.664-1.083-.582-6.457-.125-6.373 1.04.125 1.164 5.956.748 6.706-.125.208.582.416 1.165.666 1.788-1.041-.623-6.54-.166-6.456.998.125 1.207 6.123.708 6.79-.207.25.665.5 1.289.79 1.954-1.082-.582-6.414-.083-6.372 1.04.125 1.206 5.998.707 6.706-.166.208.457.375.956.583 1.455-1.208-.374-6.29.957-6.081 2.038.291 1.123 5.706-.166 6.456-1.08.25.581.5 1.205.791 1.788-1.124-.416-6.414.915-6.164 2.038.291 1.123 5.873-.208 6.54-1.165l.874 1.872c-1.083-.5-6.54.831-6.29 1.996.292 1.165 6.123-.25 6.665-1.29l.875 1.748c-1.166-.333-6.332 1.58-5.957 2.661.417 1.082 5.79-.831 6.373-1.871.334.624.667 1.29 1 1.913-1.041-.5-6.581 1.497-6.206 2.62.416 1.123 6.164-.956 6.498-2.038.374.666.75 1.373 1.124 2.08-1.124-.333-6.248 2.412-5.706 3.452.583 1.04 5.748-1.664 6.081-2.787 4.29 7.736 9.913 16.138 17.12 24.29l.583-.416Z",
    fill: "#E0E0E0"
  })), _path7 || (_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M66.353 82.809c-7.664-2.412-14.453-5.573-20.16-8.776.958 0 4.332-1.788 3.957-2.537-.416-.832-4.54 1.248-4.706 2.121-.375-.208-.75-.457-1.125-.665.916-.042 4.207-2.454 3.707-3.161-.542-.749-4.29 1.954-4.332 2.786a24.183 24.183 0 0 0-1.375-.832c.959-.083 4.124-2.454 3.624-3.119-.541-.707-4.165 1.872-4.29 2.703a37.21 37.21 0 0 1-1.333-.873c.875 0 3.999-3.12 3.374-3.785-.666-.665-3.999 2.662-3.832 3.494-.417-.291-.833-.54-1.25-.832.917-.125 3.832-3.12 3.25-3.743-.667-.624-3.791 2.495-3.791 3.369-.5-.333-.958-.666-1.416-.998.916-.167 3.79-3.078 3.207-3.702-.625-.624-3.707 2.412-3.79 3.327l-1-.748c.874-.25 3.332-3.702 2.624-4.243-.75-.499-3.207 2.953-3.166 3.868-.458-.332-.916-.707-1.374-1.04.875-.29 3.249-3.701 2.54-4.2-.707-.5-3.123 2.828-3.165 3.743-.333-.25-.666-.54-1-.79.833-.291 2.583-4.409 1.75-4.783-.792-.333-2.458 3.493-2.291 4.367-.375-.333-.792-.624-1.166-.957.833-.29 2.582-4.408 1.749-4.783-.791-.333-2.458 3.41-2.291 4.326a13.61 13.61 0 0 1-1.125-.998c3.333-4.41.958-7.113-.791-.707-.375-.333-.708-.624-1-.916.708-.582 1.666-4.7.792-4.907-.75-.208-1.708 3.202-1.542 4.2-.291-.29-.583-.54-.832-.79.75-.416 1.499-4.95.624-5.074-.791-.125-1.5 3.535-1.25 4.45-.374-.374-.75-.748-1.04-1.081.707-.54 1.416-4.866.54-5.033-.749-.166-1.457 3.244-1.29 4.243-.25-.291-.459-.5-.584-.666 0-.915-2.457-4.284-3.165-3.785-.334.25.083 1.373.958 2.579.958 1.414 1.541 1.373 2.374 2.37-.916-.374-4.374-.415-4.374.334-.041.915 4.624 1.164 5.165.499.292.29.584.623.959.956-.959-.25-4.54.458-4.374 1.248.166.873 4.623.166 5.082-.54.291.29.624.623 1 .956-1-.125-4.458.873-4.25 1.622.25.873 4.5-.208 4.957-.957.334.292.667.624 1.042.915-1-.083-4.416 1.248-4.124 1.997.333.832 4.415-.583 4.832-1.373.333.291.666.583 1.041.915-.958 0-4.373 1.789-3.999 2.537.417.79 4.29-1.164 4.624-1.996.333.291.666.54 1 .832-.917.041-4.207 2.454-3.75 3.16.542.708 4.125-1.83 4.291-2.703.375.291.75.583 1.125.915-.917 0-4.29 2.454-3.79 3.161.54.749 4.248-1.913 4.29-2.786.416.332.833.623 1.29.956-.916.042-4.206 2.454-3.706 3.161.541.707 4.165-1.871 4.29-2.745.292.25.625.458.958.707-.916.208-3.707 3.078-3.124 3.702.625.624 3.624-2.33 3.749-3.244.375.29.791.582 1.208.873-.917.166-3.79 3.078-3.208 3.702.625.624 3.708-2.412 3.79-3.328.417.292.876.583 1.292.874-.875.083-3.915 3.12-3.29 3.743.666.624 3.873-2.579 3.79-3.41.416.25.833.54 1.25.79-.875.25-3.5 3.494-2.833 4.076.708.54 3.416-2.787 3.416-3.702.458.291.916.582 1.416.874-.875.083-3.665 3.535-2.957 4.117.708.582 3.623-3.036 3.415-3.868.5.291 1 .582 1.541.915-.833.25-3.124 3.993-2.332 4.492.791.458 3.082-3.327 2.874-4.2a103.29 103.29 0 0 0 20.618 9.025l.209-.624ZM219.429 45.377c1.042 2.412 1.75 4.575 1.958 5.78a94.016 94.016 0 0 1 1.708-3.867c-1.125-.79-4.54-12.935-3.374-13.31 1.125-.166 3.957 10.149 3.915 12.145a96.29 96.29 0 0 1 1.791-3.577c-1.041-.416-2.041-13.933-.791-13.933.542-.041 1.166 3.078 1.416 6.946.167 2.454.125 4.617-.041 5.906.791-1.372 1.457-2.537 2.082-3.452-.999-.54.667-14.1 1.875-13.809 1.083.25-.209 10.606-1 12.52 1.874-2.413 2.249-3.37 5.665-6.53 6.706-6.156 8.039-4.742 1.291 1.414-3.249 3.202-4.582 2.87-6.623 5.99 1.583-1 12.455-3.495 12.871-2.372.25 1.206-12.413 3.951-13.454 3.244-.666.999-1.374 2.205-2.208 3.66 1.417-.873 13.08-2.245 13.33-1.04.083 1.248-12.705 2.538-13.704 1.748a99.47 99.47 0 0 0-1.875 3.701c1.625-.832 12.829-2.12 13.121-.956.042 1.247-12.204 2.495-13.496 1.788-.583 1.248-1.166 2.62-1.791 4.076 1.625-.832 12.829-2.121 13.121-.956 0 1.247-12.079 2.453-13.454 1.83-.5 1.247-1.041 2.578-1.541 3.95 1.499-.873 12.996-2.204 13.246-.998.041 1.248-12.288 2.496-13.538 1.789a55.064 55.064 0 0 1-1.624 3.91c1.499-.666 13.287-.25 13.37.956-.124 1.248-12.62.583-13.703-.29a37.095 37.095 0 0 1-2.166 3.826c1.166-.75 13.703.748 13.62 1.996-.083 1.248-13.495-.5-13.87-1.58a29.898 29.898 0 0 1-3.374 4.2c1.624-.291 12.954 3.203 12.704 4.409-.417 1.165-12.538-2.745-13.246-3.868-1.333 1.29-2.749 2.454-4.29 3.41 1.666.042 12.121 5.407 11.663 6.53-.625 1.082-11.871-4.907-12.33-6.114-4.04 2.371-7.247 2.662-7.372 2.704l-.083-.79c.041 0 3.082-.292 6.956-2.538-1.25-.998-5.998-11.936-4.915-12.519 1.166-.332 5.664 10.398 5.623 12.103a24.079 24.079 0 0 0 4.123-3.285c-1.208-.375-7.247-11.77-6.123-12.353 1.167-.458 6.707 10.481 6.54 11.937 1.125-1.123 2.249-2.496 3.374-4.118-1.25-.29-8.164-11.146-7.123-11.812 1.125-.54 7.414 9.733 7.456 11.272a42.686 42.686 0 0 0 2.083-3.66c-1.125.083-8.373-11.313-7.248-11.896 1.083-.582 7.581 9.94 7.498 11.396a54.99 54.99 0 0 0 1.583-3.784c-1.375-.666-7.873-10.94-6.915-11.688 1.083-.499 6.831 8.776 7.289 10.648.542-1.414 1.042-2.745 1.542-3.993-1.208-.458-6.332-12.27-5.207-12.81.541-.167 2.166 2.578 3.665 6.114Z",
    fill: "#455A64"
  })), _path8 || (_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M89.263 47.581c-.125-.915-9.038-.915-10.205-.374.583-1.04 1.208-2.288 1.708-3.785.833.54 10.497-1.04 10.372-1.955-.25-.915-9.206.707-10.205 1.456.374-1.206.666-2.537.833-4.035.583.624 10.371-2.87 9.996-3.743-.374-.873-9.455 2.496-9.955 3.41.125-1.04.167-2.162.167-3.368 1.041.25 9.747-3.702 9.414-4.575-.5-.79-8.623 2.994-9.456 3.992a29.461 29.461 0 0 0-.291-3.202c1.083.041 9.038-5.116 8.58-5.948-.624-.707-7.914 4.2-8.664 5.324-.124-1.123-.25-2.204-.333-3.244 1.166-.042 8.956-5.116 8.54-5.948-.584-.707-7.748 4.076-8.581 5.24-.084-1.205-.167-2.37-.209-3.41 1.125 0 8.997-5.116 8.54-5.947-.584-.707-7.79 4.076-8.581 5.24-.042-1.164-.042-2.246-.042-3.202.958.207 9.205-5.158 8.706-5.948-.625-.707-8.04 4.242-8.706 5.365.042-1.29.125-2.37.208-3.285.958.124 8.623-6.156 8.04-6.863-.667-.624-7.207 4.866-7.915 6.072.292-2.828 1.333-3.078 2.416-6.405 2.416-6.53 1-7.029-1.374-.499-1.25 3.369-1.167 4.118-1.583 6.447-.125-1.58-2.874-9.067-3.707-8.86-.917.25 2.707 10.024 3.54 10.066a47.124 47.124 0 0 0-.208 3.078c-.333-1.456-4.624-8.61-5.415-8.235-.833.457 4.54 9.275 5.415 9.191 0 .915 0 1.955.041 3.078-.666-1.372-6.206-7.403-6.914-6.904-.666.665 5.915 7.736 6.956 7.86.042.999.125 2.08.208 3.245-.666-1.206-7.289-6.738-7.955-6.114-.584.749 7.039 6.987 7.997 6.904.083 1.04.208 2.121.333 3.244-.958-1.123-8.122-5.407-8.664-4.7-.416.874 7.623 5.532 8.79 5.532.124 1.082.208 2.121.25 3.12-.459-.999-8.54-5.907-9.081-5.116-.542.79 8.372 6.03 9.08 5.573a38.85 38.85 0 0 1-.125 3.203c-.583-1.04-8.455-5.823-9.039-5.075-.458.832 8.04 5.823 8.956 5.574-.167 1.455-.5 2.786-.833 3.95-.375-1.039-8.04-6.57-8.622-5.822-.542.79 7.539 6.405 8.497 6.28-.5 1.456-1.083 2.704-1.666 3.66-.542-1.164-7.373-6.904-8.04-6.28-.5.79 6.499 6.53 7.748 6.78-1.833 2.87-3.79 4.117-3.832 4.117l.333.5c.084-.042 2.166-1.373 4.082-4.41.667.583 10.414.708 10.455-.249Z",
    fill: "#E0E0E0"
  })), _path9 || (_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M44.692 149.979v-101.9a8.011 8.011 0 0 1 8.04-8.026h147.66a8.012 8.012 0 0 1 8.04 8.027v101.899a8.012 8.012 0 0 1-8.04 8.028H52.732c-4.416 0-8.04-3.619-8.04-8.028Z",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M199.893 48.122H53.231v101.774h146.662V48.122Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M194.019 54.027H59.145v90.046H194.02V54.027Z",
    fill: "#E0E0E0"
  })), _path12 || (_path12 = /*#__PURE__*/react.createElement("path", {
    d: "M198.102 101.151V98.78h-34.364l-25.117 18.092H76.849l-.209-38.805 20.12 20.089 3.331-3.327-18.994-18.924h114.255v-2.371H78.973v-21.42h-4.707V75.697l.125 18.425h-18.41v4.7h18.41l.125 18.05H55.98v4.7h18.578l.125 25.122 2.374-.042-.167-25.08h59.898v25.122h2.374v-25.122h23.243l12.704 5.865-18.536 18.508 3.332 3.286 19.744-19.673 14.704 6.821 1.999-4.243-32.906-15.264h-20.785l21.826-15.721h33.615Z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/react.createElement("path", {
    d: "M102.549 144.032h-8.247V92.375h61.897V74.698h8.205v25.912h-61.855v43.422Z",
    fill: "#455A64"
  })), _path14 || (_path14 = /*#__PURE__*/react.createElement("path", {
    d: "M165.529 75.073c-.042 7.113-10.831 7.113-10.873 0 0-7.113 10.831-7.113 10.873 0Z",
    fill: "#E8505B"
  })), _path15 || (_path15 = /*#__PURE__*/react.createElement("path", {
    d: "M163.029 75.073c.041 3.826-5.957 3.826-5.916 0-.041-3.827 5.957-3.827 5.916 0Z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/react.createElement("path", {
    d: "M172.193 44.836c.833 10.19-12.122 23.333-12.122 23.333-31.364-33.232 10.039-48.039 12.122-23.333Z",
    fill: "#E8505B"
  })), _path17 || (_path17 = /*#__PURE__*/react.createElement("path", {
    d: "M166.778 44.71c-.167 8.777-13.246 8.777-13.371 0 .125-8.817 13.204-8.817 13.371 0Z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/react.createElement("path", {
    d: "M98.426 104.437v24.705l-16.328 3.494 16.328-28.199ZM114.712 132.636l-16.286-3.494v-24.705l16.286 28.199Z",
    fill: "#E8505B"
  })), _path19 || (_path19 = /*#__PURE__*/react.createElement("path", {
    d: "m114.712 132.636-16.286-3.494v-24.705l16.286 28.199Z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/react.createElement("path", {
    d: "M120.337 153.557h-5.29v2.121h5.29v-2.121ZM127.126 127.146l-3.915 11.479h71.769l-8.789-14.89c-2.874-4.908-7.748-7.819-12.996-7.819h-45.944c-.958 0-1.458 1.123-.833 1.83.792.873 2.541 2.163 4.874 2.62-1.791 1.789-3.249 4.118-4.166 6.78Z",
    fill: "#E8505B"
  })), _path21 || (_path21 = /*#__PURE__*/react.createElement("path", {
    d: "M120.337 153.557h-5.29v2.121h5.29v-2.121Z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/react.createElement("path", {
    d: "M215.931 148.108c-.125 1.123-.875 2.122-1.958 2.579l-.167.083-2.582-5.989.208-.083c1.666-.708 3.582.083 4.249 1.747.25.54.333 1.081.25 1.663Z",
    fill: "#EB996E"
  })), _path23 || (_path23 = /*#__PURE__*/react.createElement("path", {
    d: "M215.931 148.108c-.125 1.123-.875 2.122-1.958 2.579l-.166.083c.041-.041 1.416-1.663.791-3.66-.666-1.996-3.332-2.329-3.332-2.329l.208-.083c1.666-.708 3.582.083 4.249 1.747.208.54.291 1.081.208 1.663Z",
    fill: "#FFBE9D"
  })), _path24 || (_path24 = /*#__PURE__*/react.createElement("path", {
    d: "M115.421 148.732a3.243 3.243 0 0 0 2.583 1.997l.166.041.958-6.488-.25-.042a3.244 3.244 0 0 0-3.665 2.787c-.084.624 0 1.165.208 1.705Z",
    fill: "#EB996E"
  })), _path25 || (_path25 = /*#__PURE__*/react.createElement("path", {
    d: "M115.421 148.732a3.243 3.243 0 0 0 2.583 1.997l.166.041c-.041-.041-1.833-1.247-1.666-3.327.125-2.08 2.624-3.12 2.624-3.12l-.25-.041a3.244 3.244 0 0 0-3.665 2.786c-.084.583 0 1.123.208 1.664Z",
    fill: "#FFBE9D"
  })), _path26 || (_path26 = /*#__PURE__*/react.createElement("path", {
    d: "M131.25 167.365c4.532 0 8.205-3.668 8.205-8.193 0-4.526-3.673-8.194-8.205-8.194s-8.206 3.668-8.206 8.194c0 4.525 3.674 8.193 8.206 8.193Z",
    fill: "#263238"
  })), _path27 || (_path27 = /*#__PURE__*/react.createElement("path", {
    d: "M131.251 163.207a4.038 4.038 0 0 0 4.04-4.035 4.038 4.038 0 0 0-4.04-4.035 4.038 4.038 0 0 0-4.041 4.035 4.038 4.038 0 0 0 4.041 4.035Z",
    fill: "#455A64"
  })), _path28 || (_path28 = /*#__PURE__*/react.createElement("path", {
    d: "M197.478 167.365c4.532 0 8.206-3.668 8.206-8.193 0-4.526-3.674-8.194-8.206-8.194s-8.206 3.668-8.206 8.194c0 4.525 3.674 8.193 8.206 8.193Z",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/react.createElement("path", {
    d: "M197.479 163.207a4.038 4.038 0 0 0 4.041-4.035 4.038 4.038 0 0 0-4.041-4.035 4.039 4.039 0 0 0-4.041 4.035 4.039 4.039 0 0 0 4.041 4.035Z",
    fill: "#455A64"
  })), _path30 || (_path30 = /*#__PURE__*/react.createElement("path", {
    d: "M215.556 157.633c-.333.915-1.166 1.58-2.207 1.58h-6.707c0-.541-.041-1.04-.125-1.58-.749-4.326-4.54-7.612-9.08-7.612s-8.331 3.286-9.08 7.612a9.633 9.633 0 0 0-.125 1.58h-47.777c0-.541-.041-1.04-.125-1.58-.75-4.326-4.54-7.612-9.08-7.612a9.167 9.167 0 0 0-6.498 2.704c-1.666 1.663-2.708 3.951-2.708 6.488-.666 0-1.291-.166-1.874-.416a4.47 4.47 0 0 1-2.624-4.076v-5.199c0-7.486 6.081-13.517 13.537-13.517h64.396c16.162 0 19.494 14.599 20.16 20.671.084.291.042.624-.083.957Z",
    fill: "#E8505B"
  })), _path31 || (_path31 = /*#__PURE__*/react.createElement("path", {
    d: "m130.625 137.544 3.457-10.398c.75-2.038 2-3.951 3.541-5.449 1.499-1.414 3.29-2.537 5.206-3.161.5-.166 1.042-.332 1.542-.416a12.891 12.891 0 0 1 2.832-.291h25.95c4.665.042 8.997 2.454 11.58 6.489v.041l7.664 13.226h-61.772v-.041Z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path32 || (_path32 = /*#__PURE__*/react.createElement("path", {
    d: "M189.814 135.963h-56.982l2.832-8.36c.709-1.871 1.792-3.493 3.208-4.783a12.688 12.688 0 0 1 4.665-2.786 8.458 8.458 0 0 1 1.374-.375 12.88 12.88 0 0 1 2.541-.249h25.534a12.52 12.52 0 0 1 10.372 5.698l6.456 10.855Z",
    fill: "#EBEBEB"
  })), _path33 || (_path33 = /*#__PURE__*/react.createElement("path", {
    opacity: 0.2,
    d: "M149.952 135.963h-5.789l-5.332-13.143a12.696 12.696 0 0 1 4.665-2.786l6.456 15.929ZM154.367 135.963h-2.874l-6.623-16.304a12.865 12.865 0 0 1 2.541-.249h.25l6.706 16.553ZM175.277 135.963h-5.79l-6.706-16.595h5.79l6.706 16.595ZM179.693 135.963h-2.875l-6.706-16.553h2.874l6.707 16.553Z",
    fill: "#455A64"
  })), _path34 || (_path34 = /*#__PURE__*/react.createElement("path", {
    d: "M163.907 140.497h-3.833v1.913h3.833v-1.913ZM150.703 140.497h-3.833v1.913h3.833v-1.913Z",
    fill: "#E8505B"
  })), _path35 || (_path35 = /*#__PURE__*/react.createElement("path", {
    d: "M208.433 157.633c-1.625-12.436-20.369-12.436-21.952 0H154.45v-7.861c0-4.7 1.666-9.234 4.707-12.81l.208-.25v-18.675h-1.916v17.926a21.558 21.558 0 0 0-4.957 13.767v7.861h-10.288c-1.083-8.069-9.081-10.814-15.12-8.568.083-3.785.999-6.946 2.666-9.15 1.291-1.705 2.624-2.288 2.624-2.288l-.708-1.788c-.084.042-1.75.707-3.333 2.787-1.416 1.83-3.124 5.573-3.124 11.313h.084c-2.874 1.663-4.957 4.658-5.082 8.859.583.249 1.208.416 1.874.416.334-12.187 18.12-12.062 18.411 0h47.776c.209-12.062 18.203-12.062 18.411 0h6.706c1.042 0 1.875-.666 2.208-1.581h-7.164v.042Z",
    fill: "#E8505B"
  })), _path36 || (_path36 = /*#__PURE__*/react.createElement("path", {
    d: "M208.433 157.633c-1.625-12.436-20.369-12.436-21.952 0H154.45v-7.861c0-4.7 1.666-9.234 4.707-12.81l.208-.25v-18.675h-1.916v17.926a21.558 21.558 0 0 0-4.957 13.767v7.861h-10.288c-1.083-8.069-9.081-10.814-15.12-8.568.083-3.785.999-6.946 2.666-9.15 1.291-1.705 2.624-2.288 2.624-2.288l-.708-1.788c-.084.042-1.75.707-3.333 2.787-1.416 1.83-3.124 5.573-3.124 11.313h.084c-2.874 1.663-4.957 4.658-5.082 8.859.583.249 1.208.416 1.874.416.334-12.187 18.12-12.062 18.411 0h47.776c.209-12.062 18.203-12.062 18.411 0h6.706c1.042 0 1.875-.666 2.208-1.581h-7.164v.042Z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/react.createElement("path", {
    d: "M163.907 140.497h-3.833v1.913h3.833v-1.913ZM150.703 140.497h-3.833v1.913h3.833v-1.913Z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path38 || (_path38 = /*#__PURE__*/react.createElement("path", {
    d: "m24.077 166.95-.083-.042c0 .083-.084.333-.167.333l-3.041.041c-.083 0-.125-.124-.125-.208l-.25-.083c0-.457.042-.624.25-.956.75-.957-.125-5.366-.125-6.489-.167-.333 3.208-.083 3.25-.125.083 0 .124.083.124.125l-.416 4.991c-.167.957.541 1.539.583 2.413ZM39.032 167.407h-6.04c-.542-.041-.542-.541-.417-.957.333-1.497-.25-4.949-.375-6.488a.484.484 0 0 1 .458-.541c4.457-.042 3-.416 2.666 4.409-.25 1.664 1.75 1.997 2.875 2.163.79.041 2.04 1.04.833 1.414Z",
    fill: "#FFBE9D"
  })), _path39 || (_path39 = /*#__PURE__*/react.createElement("path", {
    d: "M32.365 166.741c0 .291.167.624.5.624h6.249c1.458-.541-.75-2.496-3.624-2.496-2.041.583-3.208-.998-3.125 1.872ZM20.87 167.407h2.666c1.291-.167.375-2.662-1.333-2.496-1.708-.25-2.625 2.288-1.333 2.496Z",
    fill: "#253962"
  })), _path40 || (_path40 = /*#__PURE__*/react.createElement("path", {
    d: "M37.615 166.533c.042 0 .084-.042.125-.083.25-.583.667-.791.708-.791.334-.54-.624-.166-.958.666 0 .125.042.208.125.208ZM36.615 166.408c.042 0 .125-.041.125-.083.209-.707.792-.998.833-.998.292-.624-.833.041-1.083.915-.041.083 0 .166.125.166ZM35.406 166.284c.042 0 .125-.042.125-.084.25-.707.833-1.081.833-1.123.334-.915-1.54.957-.958 1.207ZM21.245 165.701c.75-.457 1.874-.041 1.874 0 .792-.166-1.041-.832-1.957-.249-.084.041-.042.249.083.249Z",
    fill: "#DCBEA5"
  })), _path41 || (_path41 = /*#__PURE__*/react.createElement("path", {
    d: "M39.573 166.741h-7.207c.042.208.084.416.209.624h6.581c.292.042.5-.291.417-.624ZM20.87 167.407h2.666c.333 0 .625-.292.583-.624h-3.874a.64.64 0 0 0 .625.624Z",
    fill: "#213254"
  })), _path42 || (_path42 = /*#__PURE__*/react.createElement("path", {
    d: "M35.823 106.267s.667-1.83-.916-2.745l-1.167.624 2.083 2.121Z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/react.createElement("path", {
    d: "M34.74 121.073c5.874 4.492 13.246 3.494 17.453.375l.209-2.122c-9.622.749-11.996-3.868-18.203-6.654 0-.042.458 8.277.542 8.401Z",
    fill: "#E0E0E0"
  })), _path44 || (_path44 = /*#__PURE__*/react.createElement("path", {
    d: "M19.953 161.459c0 .416.042.832.042 1.289 0 0 2.25 1.497 4.498.458.875-4.742 2.75-14.973 4.624-27.243.042-.374 3.416 16.47 2.25 27.617 0 0 2.498.665 4.79-.208 1.582-5.698 1.666-16.013.5-37.64 0 0-6.832-.375-11.789-2.829-4.248 4.991-5.456 30.321-4.915 38.556Z",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/react.createElement("path", {
    d: "M33.616 112.423c.292-1.498.958-4.16-.166-4.825-.792-.416-1.917.124-1.792 1.123.084-.042-.125 2.703-.416 3.41-2.333.292 3.957 3.578 2.374.292Z",
    fill: "#FFBE9D"
  })), _path46 || (_path46 = /*#__PURE__*/react.createElement("path", {
    d: "M31.657 108.554v.125c.042-.042-.041 1.497-.208 2.579.958.624 2.125.624 2.333.624.167-1.581.792-3.536-.292-4.284-.75-.5-1.833.083-1.833.956Z",
    fill: "#EB996E"
  })), _path47 || (_path47 = /*#__PURE__*/react.createElement("path", {
    d: "M30.241 107.307c0 1.081.167 2.329.875 3.161.042.042.042.083.083.083 1.083 1.04 2.791 1.206 4.166.416 1.125-.749 1.625-1.872 1.25-2.912-.25-.582-.75-1.164-.834-1.83-.291-3.91-5.54-3.119-5.54 1.082Z",
    fill: "#FFBE9D"
  })), _path48 || (_path48 = /*#__PURE__*/react.createElement("path", {
    d: "M34.366 107.307c.125-.167-.125-.375-.25-.208-.125.208.166.416.25.208ZM35.782 107.307c.125-.167-.125-.375-.25-.208-.167.208.125.416.25.208Z",
    fill: "#263238"
  })), _path49 || (_path49 = /*#__PURE__*/react.createElement("path", {
    d: "M30.241 107.307c0 1.081.167 2.329.875 3.161.042.041.042.083.084.083-.834-1.705-.625-2.038-.25-3.244 1.25-.874 1.208-2.122 2.374-2.122 1.166 0 2.125-.166 2.125-.166-1.292-2.745-5.25-1.123-5.207 2.288Z",
    fill: "#EB996E"
  })), _path50 || (_path50 = /*#__PURE__*/react.createElement("path", {
    d: "M35.157 108.638c.25 0 .625-.125.333-.416-.291-.208-.375-.874-.375-.874-.291-.249 0 .749.334.999.208.166-.292.249-.5.124-.334.042.083.208.208.167Z",
    fill: "#263238"
  })), _path51 || (_path51 = /*#__PURE__*/react.createElement("path", {
    d: "M22.411 130.265c3.29 2.496 11.121 3.161 14.412 1.955 1.125-.458 1.25-4.201 1.125-7.861-.209-4.908-1.375-8.443-3.666-11.687-.041 0-.458-.208-.708-.25 0 .458-.083 1.747-2.374-.291 0 0-.667-.083-.916 0-.209.167-2.708 1.789-2.75 2.038-.166.79-1.04 2.745-1.957 4.991-1.042 2.662-2.166 5.366-2.625 7.819-.124 1.04-1.166 2.33-.541 3.286Z",
    fill: "#D3D3D3"
  })), _path52 || (_path52 = /*#__PURE__*/react.createElement("path", {
    d: "M30.034 105.851c.375-3.119 2.29-2.995 2.29-2.995 1.667-2.204 5.333-1.081 3.833 1.373-.875 1.539-3.082-.166-4.415 1.789-.542.79-.875 1.289-1.792 1.663 0-.041-.125-.998.084-1.83Z",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/react.createElement("path", {
    d: "M29.45 107.722c.042 1.248 1.583 1.165 1.541-.083-.041-1.206-1.583-1.165-1.541.083Z",
    fill: "#FFBE9D"
  })), _path54 || (_path54 = /*#__PURE__*/react.createElement("path", {
    d: "M35.115 109.511c.208.041.416-.083.208-.167-.041 0-.625.167-1.25-.416-.041-.041-.083-.041-.083 0 .209.5.958.583 1.125.583Z",
    fill: "#263238"
  })), _path55 || (_path55 = /*#__PURE__*/react.createElement("path", {
    d: "M30.366 112.131c.75 1.29 4.083 3.286 3.958.541-.042 0-.459-.208-.709-.25 0 .083.125 1.955-2.374-.291 0 0-.666-.125-.875 0Z",
    fill: "#fff"
  })), _path56 || (_path56 = /*#__PURE__*/react.createElement("path", {
    d: "M34.698 162.499c2.624-12.977-.166-29.738-.583-29.863-.208.125 2.25 16.928.583 29.863-1 .124-2.208.124-3.249-.416l-.125 1.497s2.5.665 4.79-.208c0 0 .167-.416.375-1.289.042 0-.75.291-1.79.416ZM22.452 162.249c2.25-14.141 4.665-30.112 4.332-30.362-.333.083-2.79 16.346-4.332 30.362-.791-.083-1.666-.291-2.499-.79 0 .416.042.832.042 1.289 0 0 2.25 1.498 4.498.458 0 0 .084-.375.209-1.123 0 0-.958.291-2.25.166Z",
    fill: "#455A64"
  })), _path57 || (_path57 = /*#__PURE__*/react.createElement("path", {
    d: "M26.034 113.42s-3.332 2.662-4.123 6.988c-1.167 6.737 2.04 10.439 8.914 12.311 0 0 .208-.832 1.124-1.123 0 0-3.29-2.537-4.123-5.574-.834-3.036-.417-7.444 1.166-9.15.041-.041-1.208-2.87-2.958-3.452Z",
    fill: "#E0E0E0"
  })), _path58 || (_path58 = /*#__PURE__*/react.createElement("path", {
    d: "M28.367 112.464c.75-.79 2.083-.873 2.291-.083.75 2.412 1.791 4.575 2.166 5.282.125-.083.25-.083.375-.125 1.708-2.454 1.333-4.741 1.333-4.741 1.083-.083 1.75.333 2.124.998 1.833.665 1.625 2.121-.083 3.244-.375.874-1.083 1.664-1.958 2.08.667 1.497 1.416 3.826.542 4.284-.417.374-1.375.54-1.416-.541 0-.915-.084-2.288-.167-3.161-.083 0-.208 0-.292-.042 0 0-.125 3.037.375 4.95.5 1.913-1.874 1.539-2.624.915-.625-.499-.083-4.367.833-6.488a6.17 6.17 0 0 1-1.583-1.248c-1-.957-7.664-4.742-1.916-5.324Z",
    fill: "#B13C36"
  })), _path59 || (_path59 = /*#__PURE__*/react.createElement("path", {
    d: "M56.22 115.986 23.97 139.519l1.45 1.982 32.252-23.533-1.45-1.982Z",
    fill: "#E8505B"
  })), _path60 || (_path60 = /*#__PURE__*/react.createElement("path", {
    d: "m40.83 127.173-16.883 12.318 1.45 1.982 16.883-12.319-1.45-1.981Z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path61 || (_path61 = /*#__PURE__*/react.createElement("path", {
    opacity: 0.4,
    d: "M83.329 110.838c1.342-7.974-4.043-15.525-12.029-16.866-7.986-1.34-15.548 4.037-16.89 12.011-1.343 7.974 4.042 15.525 12.028 16.865 7.986 1.341 15.548-4.036 16.89-12.01Z",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/react.createElement("path", {
    opacity: 0.4,
    d: "M83.809 113.753c-.5 1.456-1.25 2.828-2.166 4.076l-.875-.873-.875-.874-18.702-18.675-1.75-1.746c.042-.042.125-.084.167-.125 1.25-.874 2.54-1.58 3.915-2.038l.958.956 1 .999 16.37 16.345 1 .998.958.957ZM80.143 119.534a16.606 16.606 0 0 1-2.041 1.747c-1.292.915-2.625 1.622-4.04 2.08l-.959-.957-1-.998-16.286-16.221-1-.998-.958-.957c.792-2.287 2.125-4.367 3.874-6.114l1.708 1.706 18.994 18.966.874.873.834.873Z",
    fill: "#fff"
  })), _path63 || (_path63 = /*#__PURE__*/react.createElement("path", {
    d: "M81.767 99.155c-8.08-11.48-26.533-6.988-28.574 6.696-2.29 11.479 10.122 21.711 20.868 17.552 9.747-3.203 13.954-15.805 7.706-24.248Zm.084 12.643c-1.125 4.659-5.124 8.568-9.747 9.65-13.08 3.285-22.41-13.102-12.663-22.585 9.58-9.483 25.867-.083 22.41 12.935Z",
    fill: "#E8505B"
  })), _path64 || (_path64 = /*#__PURE__*/react.createElement("path", {
    d: "M81.767 99.155c-8.08-11.48-26.533-6.988-28.574 6.696-2.29 11.479 10.122 21.711 20.868 17.552 9.747-3.203 13.954-15.805 7.706-24.248Zm.084 12.643c-1.125 4.659-5.124 8.568-9.747 9.65-13.08 3.285-22.41-13.102-12.663-22.585 9.58-9.483 25.867-.083 22.41 12.935Z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path65 || (_path65 = /*#__PURE__*/react.createElement("path", {
    d: "M53.567 121.281c.625.499 1.166-.374.292-.457-.334-.25-.625.208-.292.457Z",
    fill: "#FFBE9D"
  })), _path66 || (_path66 = /*#__PURE__*/react.createElement("path", {
    d: "M53.984 120.99c.792.416 1.041-.665.25-.499h-.042c-.374-.25-.541.333-.208.499Z",
    fill: "#FFBE9D"
  })), _path67 || (_path67 = /*#__PURE__*/react.createElement("path", {
    d: "m54.483 120.658.292.041c.417.083.375-.541 0-.582l-.291-.042c-.417-.083-.375.541 0 .583Z",
    fill: "#FFBE9D"
  })), _path68 || (_path68 = /*#__PURE__*/react.createElement("path", {
    d: "m54.817 120.325.292.041c.416.084.375-.54 0-.582l-.292-.042c-.416-.083-.333.541 0 .583ZM34.45 131.97l-.584.416c.25.375.583.708 1 .957.375.208.75.458 1.208.624.542.832-1.708-.166-2-.25a15.68 15.68 0 0 0 1.667 1.248c.375.999-1.833-.665-2.083-.832.416.541.916.999 1.416 1.373.292 1.04-1.791-.832-2-1.081.25.457.584.873.917 1.289.125 1.04-1.458-.873-1.583-1.123-.166-.083-1-.874-1.458-1.955-.166-.374.833-1.331 1.125-1.123.25.166 1.041.166 1.208.208.333.125.75.125 1.166.249Z",
    fill: "#FFBE9D"
  })), _path69 || (_path69 = /*#__PURE__*/react.createElement("path", {
    d: "M33.658 106.891s-.042 0 0 0c-.083-.042-.083-.084-.042-.084.375-.416.875-.374.917-.374.041 0 .041.042.041.083 0 .042-.041.042-.083.042 0 0-.5-.042-.833.333.041 0 .041 0 0 0ZM35.823 106.724c-.042 0-.042 0 0 0-.042 0-.333-.249-.666-.166-.042 0-.084 0-.084-.042 0-.041 0-.083.042-.083.375-.083.708.166.708.208.042.042.042.042 0 .083ZM30.575 107.306c.041-.124-.334-.291-.625-.124-.125.083-.333.582-.125.873.041 0 .083-.042.041-.083-.041-.25-.041-.458.042-.582 0 0 .417.083.5.665 0 .042.042.042.083.042.042 0 .042-.042.042-.084-.083-.54-.458-.707-.583-.748.333-.167.541.125.625.041ZM120.71 10.564s.916-1.747 3.665-1.248c2.75.5 3.416 3.993 4.332 5.574 1.958 3.369 2.583 6.946 1.542 8.65-1.125 1.914-3.666 1.165-7.331.833-3.916-.375-5.582-3.785-3.124-8.443l.916-5.366Z",
    fill: "#263238"
  })), _path70 || (_path70 = /*#__PURE__*/react.createElement("path", {
    d: "M121.877 18.675c-1.083 1.58-1.749 9.275-1.791 9.858-1.25-.084-4.29-.333-5.623-.416-.375-2.829 3.374-8.569 6.79-9.276.374-.125.624-.166.624-.166Z",
    fill: "#E8505B"
  })), _path71 || (_path71 = /*#__PURE__*/react.createElement("path", {
    d: "m105.924 61.015 5.457-.041c0-.874-.25-2.62-.083-3.619l-2.375.291c.083.5.208 1.498-.583 1.747-1.042.333-2.166.208-2.791.998-.167.292.042.624.375.624Z",
    fill: "#FFBE9D"
  })), _path72 || (_path72 = /*#__PURE__*/react.createElement("path", {
    d: "M111.547 60.433c0 .166-.083.374-.167.54l-5.54.042c-.25 0-.458-.25-.375-.499.208-.582.916-1.456 3.457-1.622 0 0 .875.25 2.292-.042.041 0 .416.832.333 1.58Z",
    fill: "#263238"
  })), _path73 || (_path73 = /*#__PURE__*/react.createElement("path", {
    d: "M107.09 60.267a.089.089 0 0 1-.083-.084c-.209-.499-.584-.665-.584-.665-.291-.458.542-.125.792.582.042.083-.042.166-.125.166ZM107.964 60.183c-.041 0-.083-.041-.125-.083-.166-.583-.708-.832-.708-.832-.25-.5.708.042.917.79.041.042 0 .125-.084.125ZM108.964 60.017c-.042 0-.084-.042-.125-.083-.209-.582-.709-.915-.709-.915-.208-.541.667.125.917.832.041.124 0 .208-.083.166Z",
    fill: "#fff"
  })), _path74 || (_path74 = /*#__PURE__*/react.createElement("path", {
    d: "m105.465 60.474 6.082-.083c0 .166-.083.375-.167.54l-5.54.042c-.25.042-.458-.25-.375-.499Z",
    fill: "#465B92"
  })), _path75 || (_path75 = /*#__PURE__*/react.createElement("path", {
    d: "M123.251 40.136c-2.707-.125-7.372-1.58-9.413 1.83-2.208 3.743-1.666 11.646-1.458 15.472-2.958.957-4.54 0-4.54 0-1.25-7.86-5.415-25.704 8.455-23.208h9.289c1.583 3.202.208 5.864-2.333 5.906Z",
    fill: "#E8505B"
  })), _path76 || (_path76 = /*#__PURE__*/react.createElement("path", {
    d: "m112.463 61.015 5.457-.041c0-.874-.25-2.62-.084-3.619l-2.374.291c.083.5.25 1.498-.583 1.747-1.042.333-2.166.208-2.791.998-.125.292.083.624.375.624Z",
    fill: "#FFBE9D"
  })), _path77 || (_path77 = /*#__PURE__*/react.createElement("path", {
    d: "M118.086 60.433c0 .166-.083.374-.167.54l-5.54.042c-.25 0-.458-.25-.375-.499.208-.582.916-1.456 3.458-1.622 0 0 .874.25 2.291-.042.041 0 .416.832.333 1.58Z",
    fill: "#263238"
  })), _path78 || (_path78 = /*#__PURE__*/react.createElement("path", {
    d: "M113.671 60.267a.089.089 0 0 1-.083-.084c-.209-.499-.584-.665-.584-.665-.291-.458.542-.125.792.582 0 .083-.042.166-.125.166ZM114.545 60.183c-.041 0-.083-.041-.125-.083-.166-.583-.708-.832-.708-.832-.25-.5.708.042.917.79.041.042-.042.125-.084.125ZM115.504 60.017c-.042 0-.084-.042-.125-.083-.209-.582-.709-.915-.709-.915-.208-.541.667.125.917.832.083.124 0 .166-.083.166Z",
    fill: "#fff"
  })), _path79 || (_path79 = /*#__PURE__*/react.createElement("path", {
    d: "m112.046 60.474 6.082-.083c0 .166-.084.375-.167.54l-5.54.042c-.292.042-.458-.25-.375-.499Z",
    fill: "#465B92"
  })), _path80 || (_path80 = /*#__PURE__*/react.createElement("path", {
    d: "m117.044 34.23-.791 5.781c-3.457 1.373-3.707 5.116-4.041 9.234-1.582-6.322-1.457-12.852 4.832-15.015Z",
    fill: "#B13C36"
  })), _path81 || (_path81 = /*#__PURE__*/react.createElement("path", {
    d: "M126.75 40.427c-2.832 1.747-5.623-.166-7.622 3.827-1.583 3.493-.709 10.19-.25 13.226-2.958.956-4.541 0-4.541 0-1.749-6.78-5.748-22.501 5.582-23.208 3.082-.084 7.164-.084 9.914-.25 0 0 .749 4.034-3.083 6.405Z",
    fill: "#E8505B"
  })), _path82 || (_path82 = /*#__PURE__*/react.createElement("path", {
    d: "M129.873 32.4c.249 1.705-.125 3.701-.125 3.701-3.666-1.164-6.998-1.289-12.538-2.038 3.499-10.522-4.624-3.16 4.665-15.43.042 0 2.291.208 2.291.208 2.624 1.996 4.29 4.575 5.707 13.559Z",
    fill: "#E8505B"
  })), _path83 || (_path83 = /*#__PURE__*/react.createElement("path", {
    d: "M117.128 26.161c-.041 0-.083-.041-.083-.083.167-1.539 1.833-3.535 2.041-3.41.167.207-1.749 1.83-1.833 3.452-.041 0-.083.041-.125.041Z",
    fill: "#B13C36"
  })), _path84 || (_path84 = /*#__PURE__*/react.createElement("path", {
    d: "M107.381 34.853h12.329l-2.457-9.025h-12.246l2.374 9.025Z",
    fill: "#455A64"
  })), _path85 || (_path85 = /*#__PURE__*/react.createElement("path", {
    d: "M119.709 34.813H107.38v.623h12.329v-.623Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/react.createElement("path", {
    d: "M117.045 25.828h.458l2.416 8.985h5.832v.582h-6.248v-.54l-2.458-9.027Z",
    fill: "#263238"
  })), _path87 || (_path87 = /*#__PURE__*/react.createElement("path", {
    d: "M128.208 20.63c2.833 2.12 4.374 5.947 3.624 9.44-.291 1.956-1.541 3.827-3.457 4.368-.958.374-5.415.998-5.207-.583.084-.374.417-.499.75-.623.541-.208 1.083-.416 1.583-.624.916-.458 2.082-.915 2.291-1.955.416-2.412-.542-4.741-2.333-6.28-2.416-1.83.333-5.532 2.749-3.744Z",
    fill: "#FFBE9D"
  })), _path88 || (_path88 = /*#__PURE__*/react.createElement("path", {
    d: "M129.915 33.98a11.01 11.01 0 0 1-3.874.874s.25-1.58-.874-2.205c6.372-4.866-2.75-6.904-1-14.016 6.873.125 13.954 10.48 5.748 15.347Z",
    fill: "#E8505B"
  })), _path89 || (_path89 = /*#__PURE__*/react.createElement("path", {
    d: "M120.461 34.812s.541-1.913 3.832-1.705l.667 1.705h-4.499Z",
    fill: "#FFBE9D"
  })), _path90 || (_path90 = /*#__PURE__*/react.createElement("path", {
    d: "M126.792 34.813c-.459.041-.75.041-.75.041s.25-1.58-.875-2.204c0 0 .292-.167.625-.5 0 0 1.25.874 1 2.663Z",
    fill: "#B13C36"
  })), _path91 || (_path91 = /*#__PURE__*/react.createElement("path", {
    d: "M125.75 32.4c-.084 0-.125-.124-.042-.166 2.833-2.537 1.458-5.2-.25-6.946-.083-.084.042-.208.125-.125 1.791 1.83 3.166 4.783.167 7.238ZM126.75 34.812c-.541-.29 1.5-.166 3.041-.873.042 0 .083 0 .125.041 0 .042 0 .084-.042.125-1.624.624-3.082.707-3.124.707Z",
    fill: "#B13C36"
  })), _path92 || (_path92 = /*#__PURE__*/react.createElement("path", {
    d: "M124.793 21.503a.744.744 0 0 1-.667.624c-1.666-.707-.458 1.498-1.166 1.747-.583.208-.625-.54-1.125-.582-.708-.042-.875.333-1.125.083-.333-.333.5-.915.375-1.497-.083-.416-.916 0-.916-.874 0-.832 1-2.121 1-2.163.625-.333 1.916-.166 2.541-.166 0-.042.375-.042.375-.042s.25-.041.5.042c.249.665.374 2.08.208 2.828Z",
    fill: "#fff"
  })), _path93 || (_path93 = /*#__PURE__*/react.createElement("path", {
    d: "m121.919 17.843-.042.832s-.083.79-.083 2.246c0 2.038.5 1.83 1.208.374.375-.79 1.166-2.62 1.166-2.62s0-.541.042-.874l-2.291.042Z",
    fill: "#FFBE9D"
  })), _path94 || (_path94 = /*#__PURE__*/react.createElement("path", {
    d: "M124.667 15.514c0 .041 0 .083-.042.125-.041-.042-.333 1.33-.416 2.37-1 .583-2.125.5-2.333.458.042-1.539.167-3.827 1.375-4.243.791-.332 1.624.458 1.416 1.29Z",
    fill: "#EB996E"
  })), _path95 || (_path95 = /*#__PURE__*/react.createElement("path", {
    d: "M121.669 10.44c-2.958-.375-3.457 4.325-1.416 6.03l1.416-6.03Z",
    fill: "#263238"
  })), _path96 || (_path96 = /*#__PURE__*/react.createElement("path", {
    d: "M125.168 13.767c.125 1.04.166 2.205-.417 3.12-1.583 2.537-6.748.915-5.332-2.122.208-.374.333-.873.333-1.248.083-4.2 4.999-3.327 5.416.25Z",
    fill: "#FFBE9D"
  })), _path97 || (_path97 = /*#__PURE__*/react.createElement("path", {
    d: "M121.293 14.308c-.125-.125.084-.375.209-.208.125.124-.084.332-.209.208ZM119.96 14.474c-.125-.125.084-.374.209-.208.166.125-.042.374-.209.208ZM120.751 15.639c-.25.041-.625-.042-.375-.333.25-.25.25-.874.25-.874 0-.083.125-.083.125 0 0 .042-.041.707-.291.957-.042.042-.042.083-.042.083.042.083.375.083.542-.041h.083c0 .166-.208.166-.292.208Z",
    fill: "#263238"
  })), _path98 || (_path98 = /*#__PURE__*/react.createElement("path", {
    d: "M125.167 13.767c.125 1.04.166 2.205-.417 3.12.25-.666.167-1.914.167-1.914l-.375-.457c-3.707-.042-4.249-2.87-4.249-2.87 1.625-2.247 4.707-.25 4.874 2.12Z",
    fill: "#EB996E"
  })), _path99 || (_path99 = /*#__PURE__*/react.createElement("path", {
    d: "M120.585 11.271s.541 2.746 3.916 2.912l.916-.915c.417-2.413-2.458-4.867-4.832-1.997Z",
    fill: "#263238"
  })), _path100 || (_path100 = /*#__PURE__*/react.createElement("path", {
    d: "M125.959 14.058c.125 1.165-1.375 1.29-1.458.125-.125-1.165 1.374-1.29 1.458-.125Z",
    fill: "#FFBE9D"
  })), _path101 || (_path101 = /*#__PURE__*/react.createElement("path", {
    d: "M125.626 13.767c-.166-.458-1.041.041-.666.041 0 0 .416-.25.5-.041-.375.166-.5.915-.292.665 0 0 .042-.416.375-.582.125 1.04.291.333.083-.083Z",
    fill: "#263238"
  })), _path102 || (_path102 = /*#__PURE__*/react.createElement("path", {
    d: "M125.5 14.765c.041.166-.209.25-.25.083-.042-.166.208-.25.25-.083Z",
    fill: "#E8505B"
  })), _path103 || (_path103 = /*#__PURE__*/react.createElement("path", {
    d: "M121.793 24.373c0 .332-.541.332-.541 0 0-.333.541-.333.541 0ZM121.293 26.203c0 .332-.541.332-.541 0 0-.333.541-.333.541 0ZM121.293 27.866c0 .333-.541.333-.541 0 0-.332.541-.332.541 0Z",
    fill: "#fff"
  })), _path104 || (_path104 = /*#__PURE__*/react.createElement("path", {
    d: "M112.295 56.149c.042.832.084 1.33.084 1.33-2.958.957-4.541 0-4.541 0s-.083-.415-.208-1.122c.042 0 1.916.915 4.665-.208ZM118.878 57.48c-2.958.957-4.54 0-4.54 0s-.125-.374-.292-1.04c0 0 1.625.832 4.665 0 .084.624.167 1.04.167 1.04Z",
    fill: "#B13C36"
  })), _path105 || (_path105 = /*#__PURE__*/react.createElement("path", {
    d: "M120.628 34.77c-.584 0 1.541-1.414 2.166-1.08 0 .04-.042.082-.084.082-1.166.167-1.957.999-2.082.999ZM121.543 34.812c-.458-.208.916-.499 1.624-.707.042 0 .084.042.125.083 0 .042-.041.084-.083.125-.75.125-1.583.5-1.666.5Z",
    fill: "#EB996E"
  })), _path106 || (_path106 = /*#__PURE__*/react.createElement("path", {
    d: "M121.752 13.808c-.416-.29-.75-.208-.75-.208-.041 0-.083 0-.083-.041 0-.042 0-.083.042-.083 0 0 .416-.125.833.207.041.042.041.084 0 .084 0 .041 0 .041-.042.041ZM119.836 13.975c-.042 0-.042 0 0 0-.084-.042-.084-.083-.042-.083 0 0 .208-.333.541-.291.042 0 .084.041.084.083 0 .041-.042.083-.084.083-.249 0-.458.25-.458.25 0-.042-.041-.042-.041-.042ZM121.252 16.262a.32.32 0 0 1-.208-.083c-.083-.124-.042-.332.167-.499.208-.166.416-.166.541-.041.084.124.042.332-.166.499a.666.666 0 0 1-.334.124Zm.25-.582a.32.32 0 0 0-.208.083c-.125.125-.167.25-.125.292.042.083.208.041.333-.042.125-.125.167-.25.125-.291-.041-.042-.083-.042-.125-.042Z",
    fill: "#263238"
  })), _path107 || (_path107 = /*#__PURE__*/react.createElement("path", {
    d: "M227.26 120.033c-.125.042 1.374.042 1.249.167-3.082 2.662-7.706 3.494-11.121.915-1-.749-2.041-1.955-2.749-3.203l.833-1.372c6.664 4.117 9.288-2.912 14.703-3.452l-1.083 1.58-1.832 5.365Z",
    fill: "#E8505B"
  })), _path108 || (_path108 = /*#__PURE__*/react.createElement("path", {
    d: "m234.633 166.95.083-.042c0 .083.083.333.167.333l2.999.041c.083 0 .125-.124.125-.208l.25-.083c0-.457-.042-.624-.25-.957-.75-.956.125-5.324.125-6.447.167-.291-3.166-.083-3.208-.125-.083 0-.125.084-.125.125l.375 4.95c.209.957-.5 1.539-.541 2.413ZM221.594 167.407h5.999c.542-.041.5-.54.417-.956-.334-1.498.25-4.909.374-6.448a.483.483 0 0 0-.458-.54h-2.624a.46.46 0 0 0-.458.54l.5 3.827c.249 1.664-1.708 1.997-2.875 2.163-.791.042-2.041 1.082-.875 1.414Z",
    fill: "#FFBE9D"
  })), _path109 || (_path109 = /*#__PURE__*/react.createElement("path", {
    d: "M228.26 166.783c0 .291-.167.624-.5.624h-6.207c-1.458-.541.75-2.496 3.583-2.454 2.041.499 3.166-1.082 3.124 1.83ZM237.799 167.407h-2.666c-1.292-.167-.375-2.662 1.333-2.496 1.707-.208 2.624 2.288 1.333 2.496Z",
    fill: "#263238"
  })), _path110 || (_path110 = /*#__PURE__*/react.createElement("path", {
    d: "M221.095 166.782h7.164c-.041.208-.083.416-.208.624h-6.54c-.292 0-.541-.332-.416-.624ZM237.798 167.406h-2.666c-.333 0-.625-.291-.583-.624h3.832c.042.333-.25.624-.583.624Z",
    fill: "#455A64"
  })), _path111 || (_path111 = /*#__PURE__*/react.createElement("path", {
    d: "M229.342 106.267s-.042-1.955 1.708-2.288l.916.957-2.624 1.331ZM238.589 163.996s-2.833.707-4.291-.042c-.749-4.741-2.874-18.009-3.582-27.076-.041.541-1.583 21.877-1.874 27.076-1 .333-3.041.749-4.166-.083-.499-5.49-2.124-23.499.334-38.264 0 0 6.747.748 12.037-.832 1.417 4.7 1.792 33.606 1.542 39.221Z",
    fill: "#263238"
  })), _path112 || (_path112 = /*#__PURE__*/react.createElement("path", {
    d: "M238.547 162.914c-.791.167-1.541.25-2.207.25-.292-16.096-2.666-31.235-3.041-31.319-.292.208 2.083 15.181 3.041 31.319-1.333 0-2.208-.25-2.208-.25.125.666.167 1.04.167 1.04 1.458.749 4.29.042 4.29.042 0-.042-.042-.416-.042-1.082ZM228.8 163.954c-.041-.457 1.875-27.076 1.875-27.076s-.875.458-1.083 3.286a37180.78 37180.78 0 0 1-1.583 23 5.37 5.37 0 0 1-2.291.042c-.666-15.68.916-29.115.667-29.281-.417.042-2 13.601-.667 29.281a5.332 5.332 0 0 1-1.166-.333c.041.624.083.956.083.956.916.666 2.458.5 3.541.25.291-.083.499-.125.583-.166l.041.041Z",
    fill: "#455A64"
  })), _path113 || (_path113 = /*#__PURE__*/react.createElement("path", {
    d: "M230.133 113.046c-.166-1.289.042-3.119.25-3.91.334-1.497 2.708-.915 2.291.541-.083-.041-.333 2.662-.166 3.411 2.249.707-4.458 2.912-2.375-.042Z",
    fill: "#FFBE9D"
  })), _path114 || (_path114 = /*#__PURE__*/react.createElement("path", {
    d: "M232.717 109.594c0 .042 0 .083-.042.125-.042-.042-.208 1.456-.208 2.537-1.042.458-2.166.25-2.375.208-.041-1.373.125-2.62.292-3.411.417-1.331 2.541-.873 2.333.541Z",
    fill: "#EB996E"
  })), _path115 || (_path115 = /*#__PURE__*/react.createElement("path", {
    d: "M234.3 109.012c-.333 1.04-.875 2.163-1.833 2.704a2.673 2.673 0 0 1-1.25.333c-2.541.332-4.998-3.078-2.749-4.784.375-.249.708-.665.916-1.04 2-3.868 6.166-.79 4.916 2.787Z",
    fill: "#FFBE9D"
  })), _path116 || (_path116 = /*#__PURE__*/react.createElement("path", {
    d: "m229.009 109.428 1.499-.5c.042.874-.958 1.248-1.499.5Z",
    fill: "#F8F7F2"
  })), _path117 || (_path117 = /*#__PURE__*/react.createElement("path", {
    d: "m225.761 118.453-1.042 3.827c-2.207.665-4.582.541-6.706-.749 2.291 1.29 5.457.582 5.957-.208.541-.79 1.708-2.745 1.791-2.87Z",
    fill: "#B13C36"
  })), _path118 || (_path118 = /*#__PURE__*/react.createElement("path", {
    d: "m237.965 131.139-.75.873s-1.333.25-2.374-1.123c4.249-8.984-3.957-9.816-2.291-17.76 5.457.666 13.037 8.776 5.415 18.01Z",
    fill: "#E8505B"
  })), _path119 || (_path119 = /*#__PURE__*/react.createElement("path", {
    d: "M230.383 107.722c-.083-.208.25-.291.292-.083.083.166-.25.291-.292.083ZM229.092 107.265c-.083-.208.25-.291.292-.083.083.208-.25.291-.292.083Z",
    fill: "#263238"
  })), _path120 || (_path120 = /*#__PURE__*/react.createElement("path", {
    d: "M234.299 109.012c-.333 1.04-.875 2.163-1.833 2.704l-.25.125c.75-.541 1.333-1.831 1.333-1.831l.042-1.164c-.875-1.207-.208-2.288-.208-2.288-1.792.208-2.208-.957-2.208-.957-.542 0-1.083-.374-1.083-.374 2.458-2.413 5.29 1.081 4.207 3.785Z",
    fill: "#EB996E"
  })), _path121 || (_path121 = /*#__PURE__*/react.createElement("path", {
    d: "M229.009 109.469c.042-.041 1.625-.457 1.541-.582.042-.166-1.541.458-1.583.458-.041.041 0 .124.042.124ZM229.468 108.762c.125.042.208-.125.042-.125-.209.042-.667-.166-.417-.291.375-.124.958-.956.625-.832 0 0-.333.583-.667.708-.458.249.084.54.417.54Z",
    fill: "#263238"
  })), _path122 || (_path122 = /*#__PURE__*/react.createElement("path", {
    d: "m237.965 131.139-.75.873s-1.333.208-2.374-1.206c.166-.374.333-.624.458-.998-.042.041.792.957 2.666 1.331Z",
    fill: "#B13C36"
  })), _path123 || (_path123 = /*#__PURE__*/react.createElement("path", {
    d: "M237.299 132.22c.291.083.583-.25.208-.333-2.083.083-2.666-1.289-2.666-1.372-.917-.5.167 1.83 2.458 1.705Z",
    fill: "#455A64"
  })), _path124 || (_path124 = /*#__PURE__*/react.createElement("path", {
    d: "M224.01 131.971s.416 1.747 3.707 2.62c.958.25 1.5.125 1.625-.541.083-.332.25-.915.583-1.123 0 0 .75.333 1 .791.625.998 1.541.083 1.999-.957.542-1.289 1.958-2.371 2.25-3.452l-11.164 2.662Z",
    fill: "#fff"
  })), _path125 || (_path125 = /*#__PURE__*/react.createElement("path", {
    d: "M237.423 129.766c-.125.208-.166.166-.291.042-2.958-2.205-4.041 2.62-7.206 2.703-3.249.333-5.04.499-5.957-.582-1.541-2.412.917-13.102 2.916-15.68.875-1.331 2.416-2.537 3.249-3.244 0 .083-.458 1.913 2.374.083.125.041 1.042.956 1 1.414.167 2.204 5.29 12.852 3.915 15.264Z",
    fill: "#E8505B"
  })), _path126 || (_path126 = /*#__PURE__*/react.createElement("path", {
    d: "M229.217 103.522s.833-.25 1.708.124c.083-.332.291-.624.625-.873.125.374.333.79.583 1.123.083-.749.541-1.331.541-1.331.125.707 1.125 1.206 1.583 1.996l.042-.041s2.583.915.708 3.244c-.083.832-.5 1.706-.5 1.706-1.374-1.248-1.083-2.746-.458-3.162-1.125.416-2.125-.083-2.666-.831-.916-.167-1.916-.624-2.166-1.955Z",
    fill: "#263238"
  })), _path127 || (_path127 = /*#__PURE__*/react.createElement("path", {
    d: "m235.715 130.473-.667-.125c2.583-5.823-.458-8.318-2.082-11.604 3.79 4.326 4.332 6.696 2.749 11.729Z",
    fill: "#B13C36"
  })), _path128 || (_path128 = /*#__PURE__*/react.createElement("path", {
    d: "M234.881 109.677c-.416 1.165-1.874.582-1.416-.541.417-1.164 1.875-.624 1.416.541Z",
    fill: "#FFBE9D"
  })), _path129 || (_path129 = /*#__PURE__*/react.createElement("path", {
    d: "M234.466 109.844c.25-.292.25-.749.125-.874-.209-.208-.625-.208-.625-.083.041.125.333-.083.541.125.25.208-.208.748-.041.832Z",
    fill: "#263238"
  })), _path130 || (_path130 = /*#__PURE__*/react.createElement("path", {
    d: "M233.924 109.677c.084 0 .25-.416.709-.416.041 0 .083-.041.083-.041-.333-.333-1.083.457-.792.457Z",
    fill: "#263238"
  })), _path131 || (_path131 = /*#__PURE__*/react.createElement("path", {
    d: "M233.425 113.296c0 1.081-2.791 2.038-2.916 2.038l-.333-.999c-.417.125-.792.708-.792.708-1.249-1.165-.083-2.205.792-1.997 0 .083-.209 1.664 2.374.042.292-.167.875.208.875.208Z",
    fill: "#fff"
  })), _path132 || (_path132 = /*#__PURE__*/react.createElement("path", {
    d: "M216.221 116.914c0 .874-1.166 1.581-1.166 1.581l-.375-.624.833-1.373c.208.167.458.291.708.416Z",
    fill: "#B13C36"
  })), _path133 || (_path133 = /*#__PURE__*/react.createElement("path", {
    d: "M214.223 114.086c-.334.208.208.832.166 1.206-.541-.249-.999-.665-.999-.665a27.693 27.693 0 0 1-1.292-1.789c-1-.457.583 1.789.708 2.08-.583-.499-1.166-.998-1.708-1.539-1.124-.249 1.125 1.83 1.333 2.08-.624-.375-1.249-.79-1.791-1.29-1.166-.124 1.292 1.789 1.583 1.955-.5-.083-1.499-.956-1.791-.748-.292.499 2.999 2.246 4.124 2.495.416.125 1-.915.916-1.331-.083-.374-.375-.832-.458-1.04-.125-.374-.291-1.372-.791-1.414Z",
    fill: "#FFBE9D"
  })), _path134 || (_path134 = /*#__PURE__*/react.createElement("path", {
    d: "M217.388 121.073c.041.042.083.042.083.084l-.083-.084Z",
    fill: "#465B92"
  })), _path135 || (_path135 = /*#__PURE__*/react.createElement("path", {
    d: "M231.258 107.681c-.041 0-.041-.042-.083-.042 0 0-.125-.457-.792-.665-.041 0-.041-.042-.041-.083 0-.042.041-.042.083-.042.708.25.875.749.875.749.042.041 0 .083-.042.083ZM229.134 106.766s-.041 0-.041-.042c-.042-.041-.042-.083 0-.083.333-.291.833-.041.833-.041.042 0 .042.041.042.083 0 .041-.042.041-.084.041 0 0-.416-.208-.708.042h-.042Z",
    fill: "#263238"
  })));
};
/* harmony default export */ var usefoolMap = (SvgUsefoolMap);
;// CONCATENATED MODULE: ./components/home/HomeUsefool.js
















var HomeUsefool = function(location) {
    var region = location.region;
    var locations = location.locations;
    var setBuildingsState = (0,buildings/* useBuildingsDispatch */.YK)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,context_location/* useLocationProvider */.b8)(), 2), locationState = ref[0], setLocationState = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,objects/* useObjectsProvider */.v8)(), 2), objectsState = ref1[0], setObjectsState = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)([
        "region"
    ]), 2), cookie = ref2[0], setCookie = ref2[1];
    var ref3 = (0,react.useState)(false), isExpanded = ref3[0], setIsExpanded = ref3[1];
    var router = (0,next_router.useRouter)();
    /** FUNCTIONS */ var handleOnClick = function(e) {
        setIsExpanded(!isExpanded);
    };
    /** HANDLERS */ var handleLocationClick = function(v) {
        if (locationState.code === v.code) return;
        setLocationState({
            type: "SET_LOCATION",
            payload: (0,_object_spread/* default */.Z)({}, locationState, v)
        });
        var newReference = [];
        newReference.locality = [];
        var currentDate = new Date();
        var cookieDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 3, currentDate.getDate());
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return axios.post("https://baza.estate/api/v2" + "/objects/reference", {
                                region: v.region
                            });
                        case 3:
                            response = _ctx.sent;
                            if (!(!response.data || response.data.status !== "ok")) {
                                _ctx.next = 6;
                                break;
                            }
                            throw new Error(response.data.text);
                        case 6:
                            if (response.data.data.location["localityName"].length > 0) {
                                response.data.data.location["localityName"].map(function(l) {
                                    return newReference.locality.push({
                                        type: "option",
                                        text: l,
                                        value: l
                                    });
                                });
                                setObjectsState({
                                    type: "SET_REFERENCE",
                                    payload: newReference
                                });
                            }
                            _ctx.next = 11;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        9
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        localStorage.setItem("location", v.code);
        setCookie("region", v.code, {
            path: "/",
            expires: cookieDate
        });
        router.replace("/" + v.code);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "block",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "fixed",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (HomeUsefool_module_default()).tools,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HomeUsefool_module_default()).toolsItem,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (HomeUsefool_module_default()).toolsItemTitle,
                                    children: "Купить квартиру"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/buy/flats/1k"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "продажа",
                                                    category: "квартира",
                                                    rooms: [
                                                        "1"
                                                    ]
                                                }
                                            });
                                        },
                                        children: "1-комнатные"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/buy/flats/2k"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "продажа",
                                                    category: "квартира",
                                                    rooms: [
                                                        "2"
                                                    ]
                                                }
                                            });
                                        },
                                        children: "2-комнатные"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/buy/flats/3k"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "продажа",
                                                    category: "квартира",
                                                    rooms: [
                                                        "3"
                                                    ]
                                                }
                                            });
                                        },
                                        children: "3-комнатные"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/buy/flats/studio"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "продажа",
                                                    category: "квартира",
                                                    studio: 1
                                                }
                                            });
                                        },
                                        children: "Студии"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/buy/flats/rooms"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "продажа",
                                                    category: "квартира",
                                                    studio: 1
                                                }
                                            });
                                        },
                                        children: "Комнаты"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HomeUsefool_module_default()).toolsItem,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (HomeUsefool_module_default()).toolsItemTitle,
                                    children: "Снять квартиру"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/rent/flats/1k"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "аренда",
                                                    category: "квартира",
                                                    rooms: [
                                                        "1"
                                                    ]
                                                }
                                            });
                                        },
                                        children: "1-комнатные"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/rent/flats/2k"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "аренда",
                                                    category: "квартира",
                                                    rooms: [
                                                        "2"
                                                    ]
                                                }
                                            });
                                        },
                                        children: "2-комнатные"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/rent/flats/3k"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "аренда",
                                                    category: "квартира",
                                                    rooms: [
                                                        "3"
                                                    ]
                                                }
                                            });
                                        },
                                        children: "3-комнатные"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/rent/flats/studio"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "аренда",
                                                    category: "квартира",
                                                    studio: 1
                                                }
                                            });
                                        },
                                        children: "Студии"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/rent/flats/rooms"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "аренда",
                                                    category: "квартира",
                                                    studio: 1
                                                }
                                            });
                                        },
                                        children: "Комнаты"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HomeUsefool_module_default()).toolsItem,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (HomeUsefool_module_default()).toolsItemTitle,
                                    children: "Загородная недвижимость"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/buy/houses"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "продажа",
                                                    category: "дом"
                                                }
                                            });
                                        },
                                        children: "Купить дом"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/buy/sites"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "продажа",
                                                    category: "участок"
                                                }
                                            });
                                        },
                                        children: "Купить земельный участок"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/rent/houses"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "аренда",
                                                    category: "дом"
                                                }
                                            });
                                        },
                                        children: "Снять дом надолго"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HomeUsefool_module_default()).toolsItem,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (HomeUsefool_module_default()).toolsItemTitle,
                                    children: "Новостройки"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/buildings"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        children: "Каталог жк"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/buildings"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setBuildingsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    deadlineYear: "2023",
                                                    deadlineQuartal: "4"
                                                }
                                            });
                                        },
                                        children: "Сдача до конца 2023"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/buildings"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setBuildingsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    deadlineYear: "2024",
                                                    deadlineQuartal: "4"
                                                }
                                            });
                                        },
                                        children: "Сдача до конца 2024"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HomeUsefool_module_default()).toolsItem,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (HomeUsefool_module_default()).toolsItemTitle,
                                    children: "Коммерчесская недвижимость"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/buy/commercial"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "продажа",
                                                    category: "коммерция",
                                                    commercialType: [
                                                        "офисное помещение"
                                                    ]
                                                }
                                            });
                                        },
                                        children: "Купить офис"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/buy/commercial"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "продажа",
                                                    category: "коммерция",
                                                    commercialType: [
                                                        "офисное помещение"
                                                    ]
                                                }
                                            });
                                        },
                                        children: "Купить склад"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/buy/commercial"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "продажа",
                                                    category: "коммерция",
                                                    commercialType: [
                                                        "производственное помещение"
                                                    ]
                                                }
                                            });
                                        },
                                        children: "Купить производство"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/buy/commercial"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "продажа",
                                                    category: "коммерция",
                                                    commercialType: [
                                                        "готовый бизнес"
                                                    ]
                                                }
                                            });
                                        },
                                        children: "Купить готовый бизнес"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (HomeUsefool_module_default()).toolsItem,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (HomeUsefool_module_default()).toolsItemTitle,
                                    children: [
                                        "Аренда ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "коммерции"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/rent/commercial"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "аренда",
                                                    category: "коммерция",
                                                    commercialType: [
                                                        "офисное помещение"
                                                    ]
                                                }
                                            });
                                        },
                                        children: "Арендовать офис"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/rent/commercial"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "аренда",
                                                    category: "коммерция",
                                                    commercialType: [
                                                        "офисное помещение"
                                                    ]
                                                }
                                            });
                                        },
                                        children: "Арендовать склад"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/rent/commercial"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "аренда",
                                                    category: "коммерция",
                                                    commercialType: [
                                                        "производственное помещение"
                                                    ]
                                                }
                                            });
                                        },
                                        children: "Арендовать производство"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: [
                                        "/",
                                        region,
                                        "/objects/rent/commercial"
                                    ].join(""),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        role: "button",
                                        tabIndex: 0,
                                        onClick: function() {
                                            setObjectsState({
                                                type: "SET_FILTER",
                                                payload: {
                                                    type: "аренда",
                                                    category: "коммерция",
                                                    commercialType: [
                                                        "торговое помещение"
                                                    ]
                                                }
                                            });
                                        },
                                        children: "Снять торговое помещение"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (HomeUsefool_module_default()).toolsItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (HomeUsefool_module_default()).searchByMap,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (HomeUsefool_module_default()).searchByMapText,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (HomeUsefool_module_default()).toolsItemTitle,
                                                children: "Поиск на карте"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    "Ищите жилье рядом с работой,",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "друзьями или озером"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: [
                                                    "/",
                                                    region,
                                                    "/objects/map"
                                                ].join(""),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: (HomeUsefool_module_default()).toolsItemButton,
                                                    type: "button",
                                                    children: "Искать на карте"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (HomeUsefool_module_default()).usefoolMap,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(usefoolMap, {})
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (HomeUsefool_module_default()).tools_regions,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (HomeUsefool_module_default()).toolsItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HomeUsefool_module_default()).toolsItemTitle,
                                children: "Недвижимость по регионам"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: [
                                    (HomeUsefool_module_default()).toolsItemRegions,
                                    isExpanded && (HomeUsefool_module_default()).active
                                ].join(" "),
                                children: locations.map(function(value, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: [
                                            "/",
                                            value.code
                                        ].join(""),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            role: "button",
                                            tabIndex: 0,
                                            onClick: function() {
                                                return handleLocationClick(value);
                                            },
                                            children: value.region
                                        }, index)
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: (HomeUsefool_module_default()).searchButton,
                                onClick: handleOnClick,
                                style: {
                                    marginLeft: "auto"
                                },
                                children: isExpanded ? "Свернуть регионы" : "Показать все регионы"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var home_HomeUsefool = (HomeUsefool);


/***/ }),

/***/ 7166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ home_HomeWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-text-transition/lib-esm/index.js + 7 modules
var lib_esm = __webpack_require__(6265);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./hooks/useWindowDimensions.js
var useWindowDimensions = __webpack_require__(7080);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./context/location.js
var context_location = __webpack_require__(637);
// EXTERNAL MODULE: ./context/objects.js
var objects = __webpack_require__(1563);
// EXTERNAL MODULE: ./helpers/index.js
var helpers = __webpack_require__(3725);
// EXTERNAL MODULE: ./styles/modules/home/HomeSearchSelect.module.scss
var HomeSearchSelect_module = __webpack_require__(2935);
var HomeSearchSelect_module_default = /*#__PURE__*/__webpack_require__.n(HomeSearchSelect_module);
;// CONCATENATED MODULE: ./components/home/HomeSearchSelect.js



var HomeSearchSelect = function(param) {
    var options = param.options, selected = param.selected, onChange = param.onChange;
    /** STATES */ var ref = (0,react.useState)(selected), value = ref[0], setValue = ref[1];
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    /** REFS */ var parentEl = (0,react.useRef)();
    /** FUNCTIONS */ var handleOutsideClick = function(e) {
        if (e.target.closest(".".concat((HomeSearchSelect_module_default()).select)) !== parentEl.current) setIsOpen(false);
    };
    var canDropdownDown = function() {
        var dropdownHeight = options.length * 50;
        var parentElPosition = parentEl.current.getBoundingClientRect();
        if (parentElPosition.top + parentElPosition.height + Math.min(dropdownHeight, 320) > window.innerHeight) return false;
        return true;
    };
    /** HOOKS */ (0,react.useEffect)(function() {
        document.body.addEventListener("click", handleOutsideClick);
        return function() {
            return document.body.removeEventListener("click", handleOutsideClick);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (onChange) onChange(value);
    }, [
        value
    ]);
    (0,react.useEffect)(function() {
        setValue(selected);
    }, [
        selected
    ]);
    /** TEMPLATE */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (HomeSearchSelect_module_default()).select,
        ref: parentEl,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: (HomeSearchSelect_module_default()).selectView,
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: value[0].toUpperCase() + value.substring(1)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        style: {
                            position: "absolute",
                            right: 8,
                            transition: "all 200ms",
                            transform: isOpen ? "rotate(-180deg)" : "rotate(0deg)"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                            points: "6 9 12 15 18 9"
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HomeSearchSelect_module_default()).selectDropdown,
                style: !canDropdownDown() ? {
                    top: "auto",
                    bottom: "calc(100% + 6px)"
                } : null,
                children: options.map(function(v, i) {
                    if (v.hidden) return null;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: [
                            (HomeSearchSelect_module_default()).selectDropdownItem,
                            value === v.value && (HomeSearchSelect_module_default()).active
                        ].filter(Boolean).join(" "),
                        onClick: function() {
                            setValue(v.value);
                            setIsOpen(false);
                        },
                        children: v.text
                    }, i);
                })
            })
        ]
    });
};
/* harmony default export */ var home_HomeSearchSelect = (HomeSearchSelect);

// EXTERNAL MODULE: ./styles/modules/home/HomeSearchCheckbox.module.scss
var HomeSearchCheckbox_module = __webpack_require__(669);
var HomeSearchCheckbox_module_default = /*#__PURE__*/__webpack_require__.n(HomeSearchCheckbox_module);
;// CONCATENATED MODULE: ./components/home/HomeSearchCheckbox.js



var HomeSearchCheckbox = function(param) {
    var checkboxes = param.checkboxes, onChange = param.onChange;
    /** STATES */ var ref = (0,react.useState)([]), value = ref[0], setValue = ref[1];
    /** HANDLERS */ var handleCheckboxClick = function(v) {
        setValue(value.includes(v) ? value.filter(function(item) {
            return item !== v;
        }) : value.concat([
            v
        ]));
    };
    /** HOOKS */ (0,react.useEffect)(function() {
        if (onChange) onChange(value);
    }, [
        value
    ]);
    /** TEMPLATE */ return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (HomeSearchCheckbox_module_default()).checkbox,
        children: checkboxes.map(function(v, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: [
                            (HomeSearchCheckbox_module_default()).checkboxButton,
                            value.includes(v.value) && (HomeSearchCheckbox_module_default()).active
                        ].filter(Boolean).join(" "),
                        onClick: function() {
                            return handleCheckboxClick(v.value);
                        },
                        children: v.text
                    }),
                    i < Object.keys(checkboxes).length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomeSearchCheckbox_module_default()).checkboxSplitter
                    })
                ]
            }, i);
        })
    });
};
/* harmony default export */ var home_HomeSearchCheckbox = (HomeSearchCheckbox);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(7333);
// EXTERNAL MODULE: ./styles/modules/home/HomeSearchInput.module.scss
var HomeSearchInput_module = __webpack_require__(7322);
var HomeSearchInput_module_default = /*#__PURE__*/__webpack_require__.n(HomeSearchInput_module);
;// CONCATENATED MODULE: ./components/home/HomeSearchInput.js





var HomeSearchInput = function(param) {
    var inputs = param.inputs, onChange = param.onChange;
    /** STATES */ var ref = (0,react.useState)([
        "",
        ""
    ]), value = ref[0], setValue = ref[1];
    /** HOOKS */ (0,react.useEffect)(function() {
        if (onChange) onChange(value);
    }, [
        value
    ]);
    /** TEMPLATES */ return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (HomeSearchInput_module_default()).input,
        children: inputs.map(function(v, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* default */.Z, {
                        thousandSeparator: " ",
                        placeholder: v.placeholder,
                        allowNegative: false,
                        suffix: v.suffix,
                        isAllowed: function(param) {
                            var formattedValue = param.formattedValue, floatValue = param.floatValue;
                            return formattedValue === "" || floatValue <= (v.max || 9999999999);
                        },
                        onValueChange: function(x) {
                            var newValue = (0,_to_consumable_array/* default */.Z)(value);
                            newValue[i] = Number(x.value) ? Number(x.value).toString() : "";
                            setValue(newValue);
                        }
                    }),
                    i < Object.keys(inputs).length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomeSearchInput_module_default()).inputSplitter
                    })
                ]
            }, i);
        })
    });
};
/* harmony default export */ var home_HomeSearchInput = (HomeSearchInput);

// EXTERNAL MODULE: ./components/Input.js
var Input = __webpack_require__(1121);
// EXTERNAL MODULE: ./components/Radio.js
var Radio = __webpack_require__(8801);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(2077);
// EXTERNAL MODULE: ./styles/modules/home/HomeSearch.module.scss
var HomeSearch_module = __webpack_require__(3675);
var HomeSearch_module_default = /*#__PURE__*/__webpack_require__.n(HomeSearch_module);
;// CONCATENATED MODULE: ./components/home/HomeSearch.js

















var Modal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6473).then(__webpack_require__.bind(__webpack_require__, 2280));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2280)
            ];
        }
    }
});
var HomeSearch = function() {
    /** STATES */ var router = (0,next_router.useRouter)();
    var locationState = (0,context_location/* useLocationState */.KJ)();
    var setObjectsState = (0,objects/* useObjectsDispatch */.U_)();
    var ref = (0,react.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react.useState)(0), foundCount = ref1[0], setFoundCount = ref1[1];
    var ref2 = (0,react.useState)("продажа"), type = ref2[0], setType = ref2[1];
    var ref3 = (0,react.useState)("квартира"), category = ref3[0], setCategory = ref3[1];
    var ref4 = (0,react.useState)(0), studio = ref4[0], setStudio = ref4[1];
    var ref5 = (0,react.useState)([]), rooms = ref5[0], setRooms = ref5[1];
    var ref6 = (0,react.useState)(""), priceFrom = ref6[0], setPriceFrom = ref6[1];
    var ref7 = (0,react.useState)(""), priceTo = ref7[0], setPriceTo = ref7[1];
    var ref8 = (0,react.useState)(""), squareFrom = ref8[0], setSquareFrom = ref8[1];
    var ref9 = (0,react.useState)(""), squareTo = ref9[0], setSquareTo = ref9[1];
    var ref10 = (0,react.useState)(""), squareAreaFrom = ref10[0], setSquareAreaFrom = ref10[1];
    var ref11 = (0,react.useState)(""), squareAreaTo = ref11[0], setSquareAreaTo = ref11[1];
    var ref12 = (0,react.useState)(""), commercialType = ref12[0], setCommercialType = ref12[1];
    var ref13 = (0,react.useState)(false), isModalSuggestVisible = ref13[0], setIsModalSuggestVisible = ref13[1];
    var ref14 = (0,react.useState)(false), isModalSuccessVisible = ref14[0], setIsModalSuccessVisible = ref14[1];
    var ref15 = (0,react.useState)(""), clientName = ref15[0], setClientName = ref15[1];
    var ref16 = (0,react.useState)(""), clientPhone = ref16[0], setClientPhone = ref16[1];
    var ref17 = (0,react.useState)("продать"), objectType = ref17[0], setObjectType = ref17[1];
    var ref18 = (0,react.useState)("квартира"), objectCategory = ref18[0], setObjectCategory = ref18[1];
    var ref19 = (0,react.useState)(""), objectAddress = ref19[0], setObjectAddress = ref19[1];
    var clientNameId = (0,react.useRef)();
    var clientPhoneId = (0,react.useRef)();
    /** HANDLERS */ var handleFormSubmit = function() {
        clientNameId.current.setError(clientName.length <= 3);
        clientPhoneId.current.setError(clientPhone.length !== 11);
        if (clientName.length > 3 && clientPhone.length === 11) {
            setIsModalSuggestVisible(false);
            setIsModalSuccessVisible(true);
            axios_default().post("https://baza.estate/api/v2" + "/client", {
                clientName: clientName,
                clientPhone: clientPhone,
                pathName: "/",
                objectFormat: objectType,
                categoryType: objectCategory,
                objectAddress: objectAddress,
                whatComponent: "HomeSearch",
                location: locationState.region,
                platform: "web"
            });
        }
    };
    var handleSearchClick = function() {
        var newSearch = {};
        var newLink = locationState.code + "/objects";
        switch(type){
            default:
            case "продажа":
                newSearch.type = "продажа";
                newLink += "/buy";
                break;
            case "аренда":
                newSearch.type = "аренда";
                newLink += "/rent";
                break;
        }
        switch(category){
            default:
            case "квартира":
                newSearch.category = "квартира";
                newLink += "/flats";
                break;
            case "комната":
                newSearch.category = "комната";
                newLink += "/rooms";
                break;
            case "дом":
                newSearch.category = "дом";
                newLink += "/houses";
                break;
            case "участок":
                newSearch.category = "участок";
                newLink += "/sites";
                break;
            case "коммерция":
                newSearch.category = "коммерция";
                newLink += "/commercial";
                break;
        }
        newSearch.priceFrom = priceFrom;
        newSearch.priceTo = priceTo;
        if (category === "квартира") {
            if (studio && rooms.length === 0) newLink += "/studio";
            else if (!studio && rooms.length === 1) {
                switch(rooms[0]){
                    case "1":
                        newLink += "/1k";
                        break;
                    case "2":
                        newLink += "/2k";
                        break;
                    case "3":
                        newLink += "/3k";
                        break;
                    case "4":
                        newLink += "/4k";
                        break;
                    default:
                        break;
                }
            }
        }
        if (category === "квартира" && (rooms.length || studio)) {
            if (studio) newSearch.studio = 1;
            newSearch.rooms = rooms.filter(function(it) {
                return it !== "студия";
            });
        }
        if (category === "дом" || category === "комната") {
            newSearch.squareFrom = squareFrom;
            newSearch.squareTo = squareTo;
        }
        if (category === "коммерция") {
            newSearch.commercialType = commercialType;
        }
        if (category === "участок") {
            newSearch.squareAreaFrom = squareAreaFrom;
            newSearch.squareAreaTo = squareAreaTo;
        }
        setObjectsState({
            type: "SET_FILTER",
            payload: newSearch
        });
        setObjectsState({
            type: "SET_SORTING",
            payload: {}
        });
        setObjectsState({
            type: "SET_PAGINATION",
            payload: {}
        });
        router.push("".concat(newLink).concat((0,helpers/* JSONToQuery */.vp)(newSearch, [
            "type",
            "category",
            category === "квартира" && newSearch.studio && !newSearch.rooms.length && "studio",
            category === "квартира" && !newSearch.studio && newSearch.rooms && newSearch.rooms.length === 1 && "rooms"
        ])));
    };
    /** HOOKS */ (0,react.useEffect)(function() {
        if (!locationState.isLoaded) return;
        var controller = new AbortController();
        var signal = controller.signal;
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setIsLoading(true);
                            _ctx.next = 3;
                            return (0,helpers/* sleep */._v)(300);
                        case 3:
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return axios_default().post("https://baza.estate/api/v2" + "/objects", {
                                type: type,
                                category: category,
                                rooms: category === "квартира" ? rooms : [],
                                studio: category === "квартира" ? studio : 0,
                                priceFrom: priceFrom,
                                priceTo: priceTo,
                                squareFrom: category === "дом" ? squareFrom : "",
                                squareTo: category === "дом" ? squareTo : "",
                                squareAreaFrom: category === "участок" ? squareAreaFrom : "",
                                squareAreaTo: category === "участок" ? squareAreaTo : "",
                                commercialType: category === "коммерция" ? commercialType : "",
                                location: locationState.region,
                                stat: 1
                            }, {
                                signal: signal
                            });
                        case 6:
                            response = _ctx.sent;
                            if (!(!response.data || response.data.status !== "ok")) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(response.data.text);
                        case 9:
                            setFoundCount(response.data.data.count);
                            setIsLoading(false);
                            _ctx.next = 15;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](3);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        13
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        return function() {
            return controller.abort();
        };
    }, [
        locationState,
        type,
        category,
        studio,
        rooms,
        priceFrom,
        priceTo,
        squareFrom,
        squareTo,
        squareAreaFrom,
        squareAreaTo,
        commercialType
    ]);
    /** TEMPLATE */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (HomeSearch_module_default()).search,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (HomeSearch_module_default()).searchTabs,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: [
                            (HomeSearch_module_default()).searchTabsButton,
                            type === "продажа" && (HomeSearch_module_default()).active
                        ].filter(Boolean).join(" "),
                        onClick: function() {
                            return setType("продажа");
                        },
                        type: "button",
                        children: "Купить"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomeSearch_module_default()).searchTabsSplitter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: [
                            (HomeSearch_module_default()).searchTabsButton,
                            category === "участок" && (HomeSearch_module_default()).disabled,
                            type === "аренда" && (HomeSearch_module_default()).active
                        ].filter(Boolean).join(" "),
                        onClick: function() {
                            if (category === "участок") return;
                            setType("аренда");
                        },
                        type: "button",
                        children: "Снять"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomeSearch_module_default()).searchTabsSplitter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (HomeSearch_module_default()).searchTabsButton,
                        //onClick={() => setIsModalSuggestVisible(true)}
                        onClick: function() {
                            return router.push("/".concat(locationState.code, "/add"));
                        },
                        type: "button",
                        children: "Продать"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomeSearch_module_default()).searchTabsSplitter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (HomeSearch_module_default()).searchTabsButton,
                        onClick: function() {
                            return router.push("/".concat(locationState.code, "/add"));
                        },
                        //onClick={() => setIsModalSuggestVisible(true)}
                        type: "button",
                        children: "Сдать"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (HomeSearch_module_default()).searchFilters,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeSearchSelect, {
                        options: [
                            {
                                text: "Квартира",
                                value: "квартира"
                            },
                            {
                                text: "Комната",
                                value: "комната"
                            },
                            {
                                text: "Дом",
                                value: "дом"
                            },
                            {
                                text: "Участок",
                                value: "участок",
                                hidden: type === "аренда"
                            },
                            {
                                text: "Коммерция",
                                value: "коммерция"
                            }
                        ],
                        selected: "квартира",
                        onChange: function(v) {
                            return setCategory(v);
                        }
                    }),
                    category === "квартира" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HomeSearch_module_default()).searchFiltersSplitter
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeSearchCheckbox, {
                                checkboxes: [
                                    {
                                        text: "Студия",
                                        value: "студия"
                                    },
                                    {
                                        text: "1К",
                                        value: "1"
                                    },
                                    {
                                        text: "2К",
                                        value: "2"
                                    },
                                    {
                                        text: "3К",
                                        value: "3"
                                    },
                                    {
                                        text: "4К+",
                                        value: "4"
                                    }
                                ],
                                onChange: function(v) {
                                    if (v.includes("студия")) setStudio(1);
                                    else setStudio(0);
                                    setRooms(v.filter(function(x) {
                                        return x !== "студия";
                                    }));
                                }
                            })
                        ]
                    }),
                    (category === "дом" || category === "комната") && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HomeSearch_module_default()).searchFiltersSplitter
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeSearchInput, {
                                inputs: [
                                    {
                                        placeholder: "Площадь от",
                                        suffix: " м\xb2",
                                        max: 9999
                                    },
                                    {
                                        placeholder: "Площадь до",
                                        suffix: " м\xb2",
                                        max: 9999
                                    }
                                ],
                                onChange: function(v) {
                                    setSquareFrom(v[0]);
                                    setSquareTo(v[1]);
                                }
                            })
                        ]
                    }),
                    category === "участок" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HomeSearch_module_default()).searchFiltersSplitter
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeSearchInput, {
                                inputs: [
                                    {
                                        placeholder: "Площадь от",
                                        suffix: " сот",
                                        max: 9999
                                    },
                                    {
                                        placeholder: "Площадь до",
                                        suffix: " сот",
                                        max: 9999
                                    }
                                ],
                                onChange: function(v) {
                                    setSquareAreaFrom(v[0]);
                                    setSquareAreaTo(v[1]);
                                }
                            })
                        ]
                    }),
                    category === "коммерция" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HomeSearch_module_default()).searchFiltersSplitter
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeSearchSelect, {
                                options: [
                                    {
                                        text: "Автосервис",
                                        value: "автосервис"
                                    },
                                    {
                                        text: "Гостиница",
                                        value: "гостиница"
                                    },
                                    {
                                        text: "Готовый бизнес",
                                        value: "готовый бизнес"
                                    },
                                    {
                                        text: "Коммерческая земля",
                                        value: "коммерческая земля"
                                    },
                                    {
                                        text: "Общепит",
                                        value: "общепит"
                                    },
                                    {
                                        text: "Офисное помещение",
                                        value: "офисное помещение"
                                    },
                                    {
                                        text: "ПСН",
                                        value: "псн"
                                    },
                                    {
                                        text: "Производственное помещение",
                                        value: "производственное помещение"
                                    },
                                    {
                                        text: "Склад",
                                        value: "склад"
                                    },
                                    {
                                        text: "Торговое помещение",
                                        value: "торговое помещение"
                                    }
                                ],
                                selected: "псн",
                                onChange: function(v) {
                                    return setCommercialType(v);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomeSearch_module_default()).searchFiltersSplitter
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeSearchInput, {
                        inputs: [
                            {
                                placeholder: "Стоимость от",
                                suffix: " ₽",
                                max: 999999999
                            },
                            {
                                placeholder: "Стоимость до",
                                suffix: " ₽",
                                max: 999999999
                            }
                        ],
                        onChange: function(v) {
                            setPriceFrom(v[0]);
                            setPriceTo(v[1]);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "green",
                        style: {
                            margin: "4px 4px 4px auto",
                            borderRadius: 6,
                            width: 120
                        },
                        loading: isLoading,
                        onClick: handleSearchClick,
                        children: foundCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                "Показать",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    style: {
                                        fontSize: 12,
                                        fontWeight: 400,
                                        opacity: 0.7
                                    },
                                    children: [
                                        foundCount,
                                        " ",
                                        (0,helpers/* declOfNum */.Ak)(foundCount, [
                                            "объект",
                                            "объекта",
                                            "объектов"
                                        ])
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "Найти"
                        })
                    })
                ]
            })
        ]
    });
};
HomeSearch.defaultProps = {
    visibility: true
};
/* harmony default export */ var home_HomeSearch = (HomeSearch);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./styles/modules/home/HomeWidgetCommercial.module.scss
var HomeWidgetCommercial_module = __webpack_require__(5144);
var HomeWidgetCommercial_module_default = /*#__PURE__*/__webpack_require__.n(HomeWidgetCommercial_module);
;// CONCATENATED MODULE: ./components/home/HomeWidgetCommercial.js




var HomeWidgetCommercial = function(param) {
    var text = param.text, region = param.region;
    /** STATES */ var setObjectsState = (0,objects/* useObjectsDispatch */.U_)();
    /** FUNCTIONS */ var handleOnClick = function() {
        setObjectsState({
            type: "SET_FILTER",
            payload: {
                type: "продажа",
                category: "квартира",
                noCommission: 1
            }
        });
    };
    /** TEMPLATE */ return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/".concat(region.region, "/objects/buy/flats?noCommission=1"),
        className: (HomeWidgetCommercial_module_default()).commercial,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (HomeWidgetCommercial_module_default()).commercial,
            onClick: handleOnClick,
            children: [
                text,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                    className: (HomeWidgetCommercial_module_default()).commercialIcon,
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                            x1: "7",
                            y1: "17",
                            x2: "17",
                            y2: "7"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                            points: "7 7 17 7 17 17"
                        })
                    ]
                })
            ]
        })
    });
};
HomeWidgetCommercial.defaultProps = {
    title: "",
    text: ""
};
/* harmony default export */ var home_HomeWidgetCommercial = ((/* unused pure expression or super */ null && (HomeWidgetCommercial)));

// EXTERNAL MODULE: ./styles/modules/home/HomeWidget.module.scss
var HomeWidget_module = __webpack_require__(4860);
var HomeWidget_module_default = /*#__PURE__*/__webpack_require__.n(HomeWidget_module);
;// CONCATENATED MODULE: ./components/home/HomeWidget.js








var titleTexts = [
    "Покупка",
    "Аренда",
    /*'Оформление',*/ "Продвижение",
    "Продажа",
    "Сдача"
];
var HomeWidget = function(region) {
    /** STATES */ var width = (0,useWindowDimensions/* default */.Z)().width;
    var ref = (0,react.useState)(0), index = ref[0], setIndex = ref[1];
    /** HOOKS */ (0,react.useEffect)(function() {
        var intervalId = setInterval(function() {
            return setIndex(function(index) {
                return index + 1;
            });
        }, 1 * 3000);
        return function() {
            return clearTimeout(intervalId);
        };
    }, []);
    /** TEMPLATE */ return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: [
            "block",
            (HomeWidget_module_default()).block
        ].join(" "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "main",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (HomeWidget_module_default()).widget,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomeWidget_module_default()).widgetImage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/main-widget5.webp",
                            layout: "fill",
                            objectFit: "cover",
                            alt: "",
                            priority: width > 992
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (HomeWidget_module_default()).widgetSearch,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (HomeWidget_module_default()).widgetSearchSlogan,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib_esm/* default */.Z, {
                                        springConfig: lib_esm/* presets.gentle */.u.gentle,
                                        inline: true,
                                        children: titleTexts[index % titleTexts.length]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "недвижимости"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_HomeSearch, {})
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var home_HomeWidget = (HomeWidget);


/***/ }),

/***/ 9748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(9815);
/* harmony import */ var _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _context_location__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(637);
/* harmony import */ var _context_objects__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1563);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1121);
/* harmony import */ var _Radio__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8801);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2077);
/* harmony import */ var _Checkbox__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5113);
/* harmony import */ var _Select__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(360);
/* harmony import */ var _styles_modules_home_HomeWidgetMobile_module_scss__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(2581);
/* harmony import */ var _styles_modules_home_HomeWidgetMobile_module_scss__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_home_HomeWidgetMobile_module_scss__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3725);

















var Modal = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 6473).then(__webpack_require__.bind(__webpack_require__, 2280));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2280)
            ];
        }
    }
});
var HomeWidgetMobile = function() {
    /** STATES */ var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var locationState = (0,_context_location__WEBPACK_IMPORTED_MODULE_6__/* .useLocationState */ .KJ)();
    var setObjectsState = (0,_context_objects__WEBPACK_IMPORTED_MODULE_7__/* .useObjectsDispatch */ .U_)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0), foundCount = ref1[0], setFoundCount = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isModalSuggestVisible = ref2[0], setIsModalSuggestVisible = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isModalSuccessVisible = ref3[0], setIsModalSuccessVisible = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), clientName = ref4[0], setClientName = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), clientPhone = ref5[0], setClientPhone = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("продать"), objectType = ref6[0], setObjectType = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("квартира"), objectCategory = ref7[0], setObjectCategory = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), objectAddress = ref8[0], setObjectAddress = ref8[1];
    var clientNameId = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)();
    var clientPhoneId = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)();
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("продажа"), type = ref9[0], setType = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)("квартира"), category = ref10[0], setCategory = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), priceFrom = ref11[0], setPriceFrom = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), priceTo = ref12[0], setPriceTo = ref12[1];
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0), studio = ref13[0], setStudio = ref13[1];
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]), rooms = ref14[0], setRooms = ref14[1];
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), squareFrom = ref15[0], setSquareFrom = ref15[1];
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), squareTo = ref16[0], setSquareTo = ref16[1];
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), squareAreaFrom = ref17[0], setSquareAreaFrom = ref17[1];
    var ref18 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(""), squareAreaTo = ref18[0], setSquareAreaTo = ref18[1];
    var ref19 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)([]), commercialType = ref19[0], setCommercialType = ref19[1];
    /** FUNCTIONS */ var handleSearchClick = function() {
        var newSearch = {};
        var newLink = "/" + locationState.code + "/objects";
        switch(type){
            default:
            case "продажа":
                newSearch.type = "продажа";
                newLink += "/buy";
                break;
            case "аренда":
                newSearch.type = "аренда";
                newLink += "/rent";
                break;
        }
        switch(category){
            default:
            case "квартира":
                newSearch.category = "квартира";
                newLink += "/flats";
                break;
            case "комната":
                newSearch.category = "комната";
                newLink += "/rooms";
                break;
            case "дом":
                newSearch.category = "дом";
                newLink += "/houses";
                break;
            case "участок":
                newSearch.category = "участок";
                newLink += "/sites";
                break;
            case "коммерция":
                newSearch.category = "коммерция";
                newLink += "/commercial";
                break;
        }
        newSearch.priceFrom = priceFrom;
        newSearch.priceTo = priceTo;
        if (category === "квартира") {
            if (studio && rooms.length === 0) newLink += "/studio";
            else if (!studio && rooms.length === 1) {
                switch(rooms[0]){
                    case "1":
                        newLink += "/1k";
                        break;
                    case "2":
                        newLink += "/2k";
                        break;
                    case "3":
                        newLink += "/3k";
                        break;
                    case "4":
                        newLink += "/4k";
                        break;
                    default:
                        break;
                }
            }
        }
        if (category === "квартира" && (rooms.length || studio)) {
            if (studio) newSearch.studio = 1;
            newSearch.rooms = rooms.filter(function(it) {
                return it !== "студия";
            });
        }
        if (category === "дом" || category === "комната") {
            newSearch.squareFrom = squareFrom;
            newSearch.squareTo = squareTo;
        }
        if (category === "коммерция") {
            newSearch.commercialType = commercialType;
        }
        if (category === "участок") {
            newSearch.squareAreaFrom = squareAreaFrom;
            newSearch.squareAreaTo = squareAreaTo;
        }
        setObjectsState({
            type: "SET_FILTER",
            payload: newSearch
        });
        setObjectsState({
            type: "SET_SORTING",
            payload: {}
        });
        setObjectsState({
            type: "SET_PAGINATION",
            payload: {}
        });
        router.push("".concat(newLink).concat((0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .JSONToQuery */ .vp)(newSearch, [
            "type",
            "category",
            category === "квартира" && newSearch.studio && !newSearch.rooms.length && "studio",
            category === "квартира" && !newSearch.studio && newSearch.rooms && newSearch.rooms.length === 1 && "rooms"
        ])));
    };
    var handleFormSubmit = function() {
        clientNameId.current.setError(clientName.length <= 3);
        clientPhoneId.current.setError(clientPhone.length !== 11);
        if (clientName.length > 3 && clientPhone.length === 11) {
            setIsModalSuggestVisible(false);
            setIsModalSuccessVisible(true);
            axios__WEBPACK_IMPORTED_MODULE_3___default().post("https://baza.estate/api/v2" + "/client", {
                clientName: clientName,
                clientPhone: clientPhone,
                pathName: "/",
                objectFormat: objectType,
                categoryType: objectCategory,
                objectAddress: objectAddress,
                whatComponent: "HomeWidgetMobile",
                location: locationState.region,
                platform: "web"
            });
        }
    };
    var handleCommercialClick = function() {
        setObjectsState({
            type: "SET_FILTER",
            payload: {
                type: "продажа",
                category: "квартира",
                noCommission: 1
            }
        });
        router.push("/".concat(locationState.code, "/objects/buy/flats?noCommission=1"));
    };
    /** HOOKS */ (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (!locationState.isLoaded) return;
        var controller = new AbortController();
        var signal = controller.signal;
        var fetchData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response;
                return _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setIsLoading(true);
                            _ctx.next = 3;
                            return (0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .sleep */ ._v)(300);
                        case 3:
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return axios__WEBPACK_IMPORTED_MODULE_3___default().post("https://baza.estate/api/v2" + "/objects", {
                                type: type,
                                category: category,
                                rooms: category === "квартира" ? rooms : [],
                                studio: category === "квартира" ? studio : 0,
                                priceFrom: priceFrom,
                                priceTo: priceTo,
                                squareFrom: category === "дом" ? squareFrom : "",
                                squareTo: category === "дом" ? squareTo : "",
                                squareAreaFrom: category === "участок" ? squareAreaFrom : "",
                                squareAreaTo: category === "участок" ? squareAreaTo : "",
                                commercialType: category === "коммерция" ? commercialType : "",
                                location: locationState.region,
                                stat: 1
                            }, {
                                signal: signal
                            });
                        case 6:
                            response = _ctx.sent;
                            if (!(!response.data || response.data.status !== "ok")) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(response.data.text);
                        case 9:
                            setFoundCount(response.data.data.count);
                            setIsLoading(false);
                            _ctx.next = 15;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](3);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        13
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        return function() {
            return controller.abort();
        };
    }, [
        locationState,
        type,
        category,
        studio,
        rooms,
        priceFrom,
        priceTo,
        squareFrom,
        squareTo,
        squareAreaFrom,
        squareAreaTo,
        commercialType
    ]);
    /** TEMPLATE */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
        className: [
            "block",
            (_styles_modules_home_HomeWidgetMobile_module_scss__WEBPACK_IMPORTED_MODULE_15___default().block)
        ].join(" "),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "fixed",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Radio__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    title: "Тип сделки",
                    radios: [
                        {
                            text: "Купить",
                            value: "продажа"
                        },
                        {
                            text: "Снять",
                            value: "аренда",
                            disabled: category === "участок"
                        }
                    ],
                    selected: type,
                    onChange: function(v) {
                        return setType(v);
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Radio__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    title: "Категория объекта",
                    radios: [
                        {
                            text: "Квартира",
                            value: "квартира"
                        },
                        {
                            text: "Комната",
                            value: "комната"
                        },
                        {
                            text: "Дом",
                            value: "дом"
                        },
                        {
                            text: "Участок",
                            value: "участок",
                            disabled: type === "аренда"
                        },
                        {
                            text: "Коммерция",
                            value: "коммерция"
                        }
                    ],
                    selected: category,
                    onChange: function(v) {
                        return setCategory(v);
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    title: "Стоимость",
                    inputs: [
                        {
                            placeholder: "Цена от",
                            mask: "money",
                            value: priceFrom,
                            max: 99999999
                        },
                        {
                            placeholder: "Цена до",
                            mask: "money",
                            value: priceTo,
                            max: 99999999
                        }
                    ],
                    onChange: function(v) {
                        setPriceFrom(v[0]);
                        setPriceTo(v[1]);
                    },
                    suffix: "₽"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    title: "Количество комнат",
                    checkboxes: [
                        {
                            text: "Студия",
                            value: "студия"
                        },
                        {
                            text: "1К",
                            value: "1"
                        },
                        {
                            text: "2К",
                            value: "2"
                        },
                        {
                            text: "3К",
                            value: "3"
                        },
                        {
                            text: "4К+",
                            value: "4"
                        }
                    ],
                    visibility: [
                        "квартира"
                    ].includes(category),
                    selected: studio ? [
                        "студия"
                    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(rooms)) : rooms,
                    onChange: function(v) {
                        if (v.includes("студия")) setStudio(1);
                        else setStudio(0);
                        setRooms(v.filter(function(x) {
                            return x !== "студия";
                        }));
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    title: "Общая площадь",
                    inputs: [
                        {
                            placeholder: "Площадь от",
                            mask: "number",
                            value: squareFrom,
                            max: 999999
                        },
                        {
                            placeholder: "Площадь до",
                            mask: "number",
                            value: squareTo,
                            max: 999999
                        }
                    ],
                    visibility: [
                        "квартира",
                        "комната",
                        "дом"
                    ].includes(category),
                    suffix: "м\xb2",
                    onChange: function(v) {
                        setSquareFrom(v[0]);
                        setSquareTo(v[1]);
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    title: "Площадь участка",
                    inputs: [
                        {
                            placeholder: "Площадь от",
                            mask: "number",
                            value: squareAreaFrom,
                            max: 999999
                        },
                        {
                            placeholder: "Площадь до",
                            mask: "number",
                            value: squareAreaTo,
                            max: 999999
                        }
                    ],
                    visibility: [
                        "дом",
                        "участок"
                    ].includes(category),
                    suffix: "сот",
                    onChange: function(v) {
                        setSquareAreaFrom(v[0]);
                        setSquareAreaTo(v[1]);
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    title: "Назначение объекта",
                    options: [
                        {
                            type: "option",
                            text: "Автосервис",
                            value: "автосервис"
                        },
                        {
                            type: "option",
                            text: "Гостиница",
                            value: "гостиница"
                        },
                        {
                            type: "option",
                            text: "Готовый бизнес",
                            value: "готовый бизнес"
                        },
                        {
                            type: "option",
                            text: "Коммерческая земля",
                            value: "коммерческая земля"
                        },
                        {
                            type: "option",
                            text: "Общепит",
                            value: "общепит"
                        },
                        {
                            type: "option",
                            text: "Офисное помещение",
                            value: "офисное помещение"
                        },
                        {
                            type: "option",
                            text: "ПСН",
                            value: "псн"
                        },
                        {
                            type: "option",
                            text: "Производственное помещение",
                            value: "производственное помещение"
                        },
                        {
                            type: "option",
                            text: "Склад",
                            value: "склад"
                        },
                        {
                            type: "option",
                            text: "Торговое помещение",
                            value: "торговое помещение"
                        }
                    ],
                    selected: [
                        "псн"
                    ],
                    visibility: [
                        "коммерция"
                    ].includes(category),
                    multiple: true,
                    onChange: function(v) {
                        return setCommercialType(v);
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_styles_modules_home_HomeWidgetMobile_module_scss__WEBPACK_IMPORTED_MODULE_15___default().actions),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Modal, {
                            title: "Предложить объект",
                            visibility: isModalSuccessVisible,
                            onClose: function() {
                                return setIsModalSuccessVisible(false);
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    style: {
                                        marginBottom: 18
                                    },
                                    children: "Спасибо за вашу заявку. Мы скоро с Вами свяжемся!"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                    src: "/images/man-with-message.svg",
                                    alt: "",
                                    style: {
                                        margin: 32
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Modal, {
                            title: "Предложить объект",
                            button: "Отправить",
                            action: handleFormSubmit,
                            visibility: isModalSuggestVisible,
                            onClose: function() {
                                return setIsModalSuggestVisible(false);
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    style: {
                                        marginBottom: 18
                                    },
                                    children: "Оставьте свои контактные данные и мы с Вами свяжемся в самые кратчайшие сроки, поможем с реализацией Вашего объекта!"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    title: "Имя",
                                    inputs: [
                                        {
                                            placeholder: "Иван Петрович",
                                            value: clientName,
                                            type: "text"
                                        }
                                    ],
                                    isWrappedStyle: true,
                                    ref: clientNameId,
                                    onChange: function(v) {
                                        return setClientName(v[0]);
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    title: "Телефон",
                                    inputs: [
                                        {
                                            placeholder: locationState.phone,
                                            value: clientPhone,
                                            mask: "phone",
                                            type: "tel"
                                        }
                                    ],
                                    isWrappedStyle: true,
                                    ref: clientPhoneId,
                                    onChange: function(v) {
                                        return setClientPhone(v[0]);
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    style: {
                                        margin: "18px -12px",
                                        borderBottom: "1px dashed rgba(0, 0, 0, 0.05)"
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Radio__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    title: "Тип сделки",
                                    radios: [
                                        {
                                            text: "Продать",
                                            value: "продать"
                                        },
                                        {
                                            text: "Сдать",
                                            value: "сдать",
                                            disabled: objectCategory === "участок"
                                        }
                                    ],
                                    selected: objectType,
                                    onChange: function(v) {
                                        return setObjectType(v);
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Radio__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    title: "Категория объекта",
                                    radios: [
                                        {
                                            text: "Квартира",
                                            value: "квартира"
                                        },
                                        {
                                            text: "Комната",
                                            value: "комната"
                                        },
                                        {
                                            text: "Дом",
                                            value: "дом"
                                        },
                                        {
                                            text: "Участок",
                                            value: "участок",
                                            disabled: objectType === "сдать"
                                        },
                                        {
                                            text: "Коммерция",
                                            value: "коммерция"
                                        }
                                    ],
                                    selected: objectCategory,
                                    onChange: function(v) {
                                        return setObjectCategory(v);
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    title: "Адрес объекта",
                                    inputs: [
                                        {
                                            placeholder: locationState.name + ", улица Пушкина, д 123",
                                            value: objectAddress,
                                            type: "text"
                                        }
                                    ],
                                    onChange: function(v) {
                                        return setObjectAddress(v[0]);
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    style: {
                                        textAlign: "center",
                                        opacity: 0.8,
                                        fontSize: 14,
                                        margin: "18px 0"
                                    },
                                    children: [
                                        "Вы соглашаетесь с",
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                            href: "/faq/policy",
                                            target: "_blank",
                                            children: "политикой конфиденциальности"
                                        }),
                                        " ",
                                        "при отправке данной формы к нам в работу"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            onClick: handleSearchClick,
                            color: "green",
                            loading: isLoading,
                            fullWidth: true,
                            children: foundCount > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                children: [
                                    "Показать ",
                                    foundCount,
                                    " ",
                                    (0,_helpers__WEBPACK_IMPORTED_MODULE_13__/* .declOfNum */ .Ak)(foundCount, [
                                        "объект",
                                        "объекта",
                                        "объектов"
                                    ])
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                children: "Найти"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
HomeWidgetMobile.defaultProps = {
    visibility: true
};
/* harmony default export */ __webpack_exports__["Z"] = (HomeWidgetMobile);


/***/ }),

/***/ 9984:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Carousel_carousel__xlK1e","carouselButton":"Carousel_carouselButton__mZAu9","no-animation":"Carousel_no-animation__JPKuY","no-border":"Carousel_no-border__aJvF6","fullWidth":"Carousel_fullWidth__zWTou","carouselButtonPrevious":"Carousel_carouselButtonPrevious__DjuBK","carouselButtonNext":"Carousel_carouselButtonNext__pkp9m","carouselContent":"Carousel_carouselContent___Mw2_","carouselItem":"Carousel_carouselItem__cTYnB","carouselItemGallery":"Carousel_carouselItemGallery__6w17x","carouselItemCounter":"Carousel_carouselItemCounter__9Vyh3","carouselItemButtons":"Carousel_carouselItemButtons__Mp11T","carouselItemButtonLeft":"Carousel_carouselItemButtonLeft__6FZC2","carouselItemButtonRight":"Carousel_carouselItemButtonRight__oYa2U","carouselItemPhotos":"Carousel_carouselItemPhotos__KE7G_","carouselItemPhoto":"Carousel_carouselItemPhoto__qWC33","carouselItemPhotoHash":"Carousel_carouselItemPhotoHash__rcfRa","carouselItemPhotoMore":"Carousel_carouselItemPhotoMore__7iukH","carouselItemPhotoMoreText":"Carousel_carouselItemPhotoMoreText__aHcS9","carouselItemLabels":"Carousel_carouselItemLabels__88fp8","carouselItemLabelsItem":"Carousel_carouselItemLabelsItem__qGf6q","yellow":"Carousel_yellow__jvp_H","red":"Carousel_red__pgbLW","carouselItemContent":"Carousel_carouselItemContent__TGKh5","carouselItemAddress":"Carousel_carouselItemAddress__RsgW6","carouselItemPrice":"Carousel_carouselItemPrice__qm0BU","green":"Carousel_green__HZZ_8","carouselItemFavorites":"Carousel_carouselItemFavorites__Lgvns","active":"Carousel_active__sQaqJ","carouselItemOldPrice":"Carousel_carouselItemOldPrice__TSjWY","carouselItemInfo":"Carousel_carouselItemInfo__AUmmF","carouselItemProperty":"Carousel_carouselItemProperty__n69rE","carouselItemButton":"Carousel_carouselItemButton__6_XZL","carouselItemActions":"Carousel_carouselItemActions__dKi7i","carouselItemMore":"Carousel_carouselItemMore__RPi_G","carouselItemDummy":"Carousel_carouselItemDummy__QzyQR"};

/***/ }),

/***/ 1385:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cb":"Checkbox_cb__zNEBc","inline":"Checkbox_inline__CYSFn","cbTitle":"Checkbox_cbTitle__452ih","cbContent":"Checkbox_cbContent__KmkMt","cbChekbox":"Checkbox_cbChekbox__d52mx","disabled":"Checkbox_disabled__vYV7z","active":"Checkbox_active__c7_cW"};

/***/ }),

/***/ 4914:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"rd":"Radio_rd__0BfzT","inline":"Radio_inline___zsgd","rdTitle":"Radio_rdTitle__btW0q","rdContent":"Radio_rdContent__fCwBL","rdRadio":"Radio_rdRadio__IL3oA","disabled":"Radio_disabled___WB5e","active":"Radio_active__OTBHA"};

/***/ }),

/***/ 7865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skelet":"Skelet_skelet__Z3L3p","wheeeee":"Skelet_wheeeee__aGXk5","invert":"Skelet_invert__PLaK3"};

/***/ }),

/***/ 8085:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"journal":"HomeNews_journal__RcoLo","journalItem":"HomeNews_journalItem__mTFLs","journalItemBackground":"HomeNews_journalItemBackground___Lq5x","journalItemContent":"HomeNews_journalItemContent__gt_s6","journalItemTitle":"HomeNews_journalItemTitle__aCDke","journalItemDescription":"HomeNews_journalItemDescription__FN9Yd","journalItemFooter":"HomeNews_journalItemFooter___W62H","journalItemReadMore":"HomeNews_journalItemReadMore__hEGkF","journalGroup":"HomeNews_journalGroup__7YYrk","journalGroupItem":"HomeNews_journalGroupItem__HNCmv","journalItemImage":"HomeNews_journalItemImage__FvrAx","journalItemCategories":"HomeNews_journalItemCategories__ZFz3i","journalItemDate":"HomeNews_journalItemDate__dlkCl","journalGroupAction":"HomeNews_journalGroupAction__GvyFJ"};

/***/ }),

/***/ 3675:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search":"HomeSearch_search__EikAx","searchTabs":"HomeSearch_searchTabs__LwfWl","searchTabsSplitter":"HomeSearch_searchTabsSplitter__lqpMy","searchTabsButton":"HomeSearch_searchTabsButton__cL4rE","disabled":"HomeSearch_disabled__0nycK","active":"HomeSearch_active__re6x1","searchFilters":"HomeSearch_searchFilters__QjLtR","searchFiltersSplitter":"HomeSearch_searchFiltersSplitter__SNgxK"};

/***/ }),

/***/ 669:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"HomeSearchCheckbox_checkbox__LLL_L","checkboxButton":"HomeSearchCheckbox_checkboxButton__bDfz5","active":"HomeSearchCheckbox_active__hxuNO","checkboxSplitter":"HomeSearchCheckbox_checkboxSplitter__1z6qg"};

/***/ }),

/***/ 7322:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"HomeSearchInput_input__FmG2n","inputSplitter":"HomeSearchInput_inputSplitter__3Bhh5"};

/***/ }),

/***/ 2935:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select":"HomeSearchSelect_select__sC6ZL","selectView":"HomeSearchSelect_selectView___PplA","selectViewHidden":"HomeSearchSelect_selectViewHidden__h0hK6","selectDropdown":"HomeSearchSelect_selectDropdown__wCI5r","selectDropdownItem":"HomeSearchSelect_selectDropdownItem__glCh7","active":"HomeSearchSelect_active__GLiCk"};

/***/ }),

/***/ 2628:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tools_regions":"HomeUsefool_tools_regions__srSrW","toolsItem":"HomeUsefool_toolsItem__xD1NQ","toolsItemRegions":"HomeUsefool_toolsItemRegions__hsWp8","active":"HomeUsefool_active__j2y0m","toolsItemTitle":"HomeUsefool_toolsItemTitle__f4mBr","toolsItemSubtitle":"HomeUsefool_toolsItemSubtitle__Tnkhy","toolsItemButton":"HomeUsefool_toolsItemButton__NOe6E","tools":"HomeUsefool_tools__m_quh","no-animation":"HomeUsefool_no-animation__Uldwp","no-border":"HomeUsefool_no-border__sPwuY","fullWidth":"HomeUsefool_fullWidth__iz80v","searchByMap":"HomeUsefool_searchByMap__Ro5Mf","usefoolMap":"HomeUsefool_usefoolMap__816XY"};

/***/ }),

/***/ 4860:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"HomeWidget_block__1KIaA","widget":"HomeWidget_widget__YHZrA","widgetImage":"HomeWidget_widgetImage__PC5kO","widgetSearch":"HomeWidget_widgetSearch__TBtL2","widgetSearchSlogan":"HomeWidget_widgetSearchSlogan__MyMZ1"};

/***/ }),

/***/ 5144:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"commercial":"HomeWidgetCommercial_commercial__A7BKz","commercialIcon":"HomeWidgetCommercial_commercialIcon__LwRop","pulse":"HomeWidgetCommercial_pulse__v0gux"};

/***/ }),

/***/ 2581:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"HomeWidgetMobile_block__pZ1cv","group":"HomeWidgetMobile_group__eANU7","groupButton":"HomeWidgetMobile_groupButton__tvrgu","groupButtonFake":"HomeWidgetMobile_groupButtonFake__POgMT","actions":"HomeWidgetMobile_actions__GYgCc","description":"HomeWidgetMobile_description__tDgZx"};

/***/ })

}]);